import React, {useEffect, useRef, useState} from 'react';
import '../../css/mobile/MAdminOrderChatPg.css'
// [구매대행 API] 상점사 채팅탭
import AdminStoreChatTab from "../../components/web/layoutsadmin/AdminStoreChatTab";
import useVisualViewportVars from "../../services/visualViewport";
import axios from '../../services/axiosInstance';
import profileDefaultImg from "../../assets/img/profileDefaultImg.png";
import ordChatListImg from "../../assets/img/ordChatListImg.png";
import mainChatPeople from "../../assets/img/mainChatPeople.png";
import trash from "../../assets/img/mainChatTrash.png";
import mainChatUpload from "../../assets/img/mainChatUpload.png";
import mainChatEmoji from "../../assets/img/mainChatEmoji.png";
import mainChatSend from "../../assets/img/mainChatSend.png";
import commonClose from "../../assets/img/commonClose.png";

import Picker from "@emoji-mart/react";
import MMsgSelectModal from "../../components/mobile/MMSgSelectModal";
import MChatFileUploadModal from "../../components/mobile/MChatFileUploadModal";
import MChatFileDownModal from "../../components/mobile/MChatFileDownModal";
import MChatModifyModal from "../../components/mobile/MChatModifyModal";
import chatFileImg from "../../assets/img/chatFolderImg.png";
import commonMacro from "../../assets/img/commonMacro.png";
import DOMPurify from "dompurify";
import Linkify from "react-linkify";
import {useWebSocket} from "../../services/WebsocketContext";
import MMsgCheckModal from "../../components/mobile/MMsgCheckModal";
import MChatFileUpload from "../../components/mobile/MChatFileUpload";
import MsgSelectModal from "../../components/web/modal/MsgSelectModal";
import AdminYmdEvent from "../../components/web/layoutsadmin/AdminYmdEvent";
import MAdminYmdEvent from "./MAdminYmdEvent";

function MAdminOrderChatPg({setNoApply}) {

    const [memberInfo, setMemberInfo] = useState([{}]);
    const [adminInfo, setAdminInfo] = useState([]);
    const LCAT = localStorage.getItem('adminToken');

    useEffect(() => {
        // 페이지 진입 시 부모의 padding을 제거
        setNoApply(true);

        // 페이지 나갈 때 원상 복구
        return () => setNoApply(false);
    }, [setNoApply]);

    /** endregion */

    /** region Function */

    const [showEmoji, setShowEmoji] = useState(false);
    const [macroOpen, setMacroOpen] = useState(false);
    const [favFn, setFavFn] = useState(false);

    const toggleMenu = () => {
        setFavFn(!favFn);
    };

    //region DateSelect

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const startHandle = (e) => {
        setStartDate(e.target.value);
    };
    const endHandle = (e) => {
        setEndDate(e.target.value);
    };
    const stringStartDate = startDate.replace(/-/g, '');
    const stringEndDate = endDate.replace(/-/g, '');

    const currentDate = new Date();
    const oneWeekAgo = new Date();
    oneWeekAgo.setDate(currentDate.getDate() - 7); // 1주일

    const defaultMonth = () => {
        const stringStartDate = formatDateChat(oneWeekAgo);
        const stringEndDate = formatDateChat(currentDate);
        setStartDate(stringStartDate);
        setEndDate(stringEndDate);
    }

    const formatDateChat = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    };

    const [selectedUserName, setSelectedUserName] = useState(null);
    const [selectedUserOrderNumbers, setSelectedUserOrderNumbers] = useState([]);
    const [focusedIndex, setFocusedIndex] = useState(null);
    const [focusedOrderIndex, setFocusedOrderIndex] = useState(null);
    const [chatStarted, setChatStarted] = useState(false);
    const [mstMbNum, setMstMbNum] = useState(null);
    const [mstUserNm, setMstUserNm] = useState(null);

    const handleUserNameClick = (data, index) => {
        if (focusedIndex === index) {
            setFocusedIndex(null);
        } else {
            selectedOrderNumbers(data.mstMbNum);
            setSelectedUserName(data.memberDTO.userName);
            setFocusedIndex(index);
            setFocusedOrderIndex(null);
        }
    }

    const selectedOrderNumbers = ((mstMbNum) => {
        axios({
            method: 'get',
            url: '/order/orderNumbers/',
            params: {
                mstMbNum: mstMbNum,
                startDate: stringStartDate,
                endDate: stringEndDate
            },
            headers: {
                Authorization: LCAT
            },
        })
            .then((response) => {
                const sortData = response.data.sort((a, b) => b.seqnum - a.seqnum);
                setSelectedUserOrderNumbers(sortData);
            })
    })

    const [selectedOrderNumber, setSelectedOrderNumber] = useState(null);
    const [sendMsgNum, setSendMsgNum] = useState('');

    const handleOrderNumberlick = (orderNumber, index) => {
        handleChatMessages(orderNumber)
        setFocusedOrderIndex(index);
        setMstMbNum(orderNumber.mstMbNum);
        setMstUserNm(orderNumber.mstUserNm);
        setSelectedOrderNumber(orderNumber.chatOrdNum);
        setChatStarted(true);
        // 비회원 채팅상태 닫기
        setNonChatShow(false);
        setSendMsgNum(null);
    };

    /** endregion */

    /** region Event */

    function macroViewOpen() {
        setMacroOpen(!macroOpen);
    }

    //region Chatting

    const findAdmin = (() => {
        axios({
            method: 'get',
            url: '/member/findMember',
            headers: {
                Authorization: LCAT
            },
        })
            .then((response) => {
                setAdminInfo(response.data)
            })
            .catch((error) => {
                console.log(error)
            })
    })

    const [lcOrdChatCount, setLcOrdChatCount] = useState(0);
    const [lcNUserChatCount, setLcNUserChatCount] = useState(0);
    // [구매대행 API] 비토리지가 읽지 않은 상점사 채팅메세지 총합
    const [lcStoreChatCount, setLcStoreChatCount] = useState(0);
    const selectChatCount = (() => {
        axios({
            method: 'get',
            url: '/order/selectChatCount',
        })
            .then((response) => {
                // 각 채팅총개수 합산
                // const totalChats = response.data.userChat + response.data.nonUserChat;
                // setLcChatData(totalChats);

                // 총채팅개수 각각 산출
                setLcOrdChatCount(response.data.ordChat > 999 ? 999 : response.data.ordChat);
                setLcNUserChatCount(response.data.nonUserChat > 999 ? 999 : response.data.nonUserChat);
            })
            .catch((error) => console.error(error))
    })

    /** [구매대행 API] 상점사 채팅 안읽은 메세지 총합 */
    const selectStoreChatCount = (() => {
        axios({
            method: 'get',
            url: '/storeChat/admin/unreadTotal',
            headers: {Authorization: LCAT},
        })
            .then((response) => {
                const cnt = Number(response.data || 0);
                setLcStoreChatCount(cnt > 999 ? 999 : cnt);
            })
            .catch(() => {})
    })

    useEffect(() => {
        selectStoreChatCount();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // 주문서채팅 시작
    const [memberList, setMemberList] = useState([]);
    const [message, setMessage] = useState('');
    const [chatMessages, setChatMessages] = useState([]);
    const [selectedFileUrl, setSelectedFileUrl] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [showChatFile, setShowChatFile] = useState(false);
    const [isSending, setIsSending] = useState(false); // 중복전송방지 상태변수

    const fileInputRef = useRef();

    useEffect(() => {
        findAdmin();
        selectChatCount();
    }, []);

    const [searchInput, setSearchInput] = useState('');
    const handleSearchInputChange = (event) => {
        setSearchInput(event.target.value);
    };
    const filteredMemberList = memberList.filter((member) => {
        if (!searchInput) return true; // 검색어 없으면 전체 표시

        const keyword = searchInput.toLowerCase();
        // 고객 이름 검색
        const nameMatch = member.mstUserNm && member.mstUserNm.toLowerCase().includes(keyword);
        // 채팅 내용(마지막 대화) 검색
        const contentMatch = member.chatKey && member.chatKey.toLowerCase().includes(keyword);

        return nameMatch || contentMatch;
    });

    // 웹소켓
    const isSubscribedRef = useRef(false);
    const {subscribe, unsubscribe, websocketConnect, isConnected, stompClient} = useWebSocket();

    useEffect(() => {
        const initializeConnection = async () => {
            if (!adminInfo.mbNum || isSubscribedRef.current) return;

            if (!stompClient && !isConnected) {
                await websocketConnect(adminInfo.mbNum);
            }
            if (isConnected && stompClient && !isSubscribedRef.current) {
                // --- 주문서채팅 ---
                subscribe(`/topic/admin/chatListUpdate`, (message) => {
                    onOrderListUpdateReceived(message); // 좌측 멤버리스트 업데이트용
                    selectChatCount();
                });
                subscribe(`/topic/userOrdChatRead`, (message) => {
                    onReadMessageReceived(message);
                    selectChatCount();
                });
                subscribe(`/topic/adminChatUpdate`, (message) => {
                    onChatAdminUpdate(message);
                    selectChatCount();
                });
                subscribe(`/topic/admin/chatRead`, (message) => {
                    onAdminReadUpdateReceived(message);
                    selectChatCount();
                });

                // --- 비회원채팅 ---
                subscribe(`/topic/admin/nonChatListUpdate`, (message) => {
                    onNonMemberListUpdateReceived(message); // 좌측 멤버리스트 업데이트용
                    selectChatCount();
                });
                subscribe(`/topic/nonUserChatRead`, (message) => {
                    nonOnReadMessageReceived(message);
                    selectChatCount();
                });
                subscribe(`/topic/admin/nonChatRead`, (message) => {
                    nonOnAdminReadUpdateReceived(message);
                    selectChatCount();
                });
                isSubscribedRef.current = true;
            }
        }

        initializeConnection();

        return () => {
            if (isSubscribedRef.current) {
                unsubscribe(`/topic/admin/chatListUpdate`);
                unsubscribe(`/topic/userOrdChatRead`);
                unsubscribe(`/topic/adminChatUpdate`);
                unsubscribe(`/topic/admin/chatRead`)
                unsubscribe(`/topic/admin/nonChatListUpdate`);
                unsubscribe(`/topic/nonUserChatRead`);
                unsubscribe(`/topic/admin/nonChatRead`)
                isSubscribedRef.current = false;
            }
        };
    }, [adminInfo.mbNum, isConnected, stompClient]);

    const orderSubscriptionRef = useRef(null);
    const nonMemberSubscriptionRef = useRef(null);

    // 주문서채팅 실제 채팅메세지만 업데이트
    useEffect(() => {
        if (stompClient && isConnected && subscribe) {
            // 기존 주문서 구독이 있다면 해제
            if (orderSubscriptionRef.current) {
                orderSubscriptionRef.current.unsubscribe();
                orderSubscriptionRef.current = null;
            }

            // 새로 선택된 주문서 채팅방이 있다면 구독
            if (selectedOrderNumber) {
                orderSubscriptionRef.current = subscribe(
                    `/topic/userOrdMessage/${selectedOrderNumber}`,
                    (message) => {
                        onActiveOrderMessageReceived(message); // 실제 주문서 채팅메세지 업데이트용
                        selectChatCount();
                    }
                );
            }
        }
        return () => {
            if (orderSubscriptionRef.current) {
                orderSubscriptionRef.current.unsubscribe();
                orderSubscriptionRef.current = null;
            }
        };
    }, [selectedOrderNumber, stompClient, isConnected]);

    // 비회원채팅 실제 채팅메세지만 업데이트
    useEffect(() => {
        if (stompClient && isConnected && subscribe) {
            // 기존 비회원 구독이 있다면 해제
            if (nonMemberSubscriptionRef.current) {
                nonMemberSubscriptionRef.current.unsubscribe();
                nonMemberSubscriptionRef.current = null;
            }

            // 새로 선택된 비회원 채팅방이 있다면 구독
            if (sendMsgNum) {
                nonMemberSubscriptionRef.current = subscribe(
                    `/topic/nonUserMessage/${sendMsgNum}`,
                    (message) => {
                        onActiveNonMemberMessageReceived(message); // 실제 비회원 채팅메세지 업데이트용
                        selectChatCount();
                    }
                );
            }
        }
        return () => {
            if (nonMemberSubscriptionRef.current) {
                nonMemberSubscriptionRef.current.unsubscribe();
                nonMemberSubscriptionRef.current = null;
            }
        };
    }, [sendMsgNum, stompClient, isConnected]);

    const selectedOrderNumberRef = useRef(selectedOrderNumber);
    const chatStartedRef = useRef(chatStarted);
    const mstUserNmRef = useRef(mstUserNm);
    const selectedOrderNumbersRef = useRef(selectedOrderNumbers);

    // 함수 내 비동기로 인해 미리 값 세팅
    useEffect(() => {
        selectedOrderNumberRef.current = selectedOrderNumber;
        chatStartedRef.current = chatStarted;
        mstUserNmRef.current = mstUserNm;
        selectedOrderNumbersRef.current = selectedOrderNumber
    }, [selectedOrderNumber, chatStarted, mstUserNm, selectedOrderNumber]);

    const onOrderListUpdateReceived = (payload) => {
        let newMessage = JSON.parse(payload.body);
        const isUserRole = newMessage.memberDTO && newMessage.memberDTO.role === '0';

        // 파일/이미지/비디오 여부 판단 (목록 표시에 필요)
        if (newMessage.chatKey.startsWith('chatFile')) {
            const filename = newMessage.chatKey.split('/').pop();
            if (isVideo(filename)) {
                newMessage.isVideo = true;
            } else if (isImage(filename)) {
                newMessage.isImage = true;
            } else {
                newMessage.isFile = true;
            }
        }

        // --- memberList (좌측 사용자 목록) 업데이트 ---
        setMemberList(prevMembers => {
            const validPrevMembers = Array.isArray(prevMembers) ? prevMembers : [];
            // 💡 모바일은 mstMbNum 기준으로 findIndex (기존 로직 유지)
            let existingMemberIndex = validPrevMembers.findIndex(member => String(member.mstMbNum) === String(newMessage.mstMbNum));

            if (existingMemberIndex === -1) {
                // 첫메시지일 경우에는 새롭게 memberList 출력업뎃
                if (isUserRole) { // 사용자가 보낸 첫 메시지만
                    const newMember = {
                        mstMbNum: newMessage.mstMbNum,
                        mstUserNm: newMessage.mstUserNm,
                        seqnum: newMessage.seqnum,
                        unreadCount: 1, // 첫 메시지 = 안읽음 1
                        chatKey: newMessage.chatKey,
                        regTime: newMessage.regTime,
                        memberDTO: newMessage.memberDTO
                        // (newMessage.isVideo 등 플래그도 같이 저장됨)
                    };
                    return [...validPrevMembers, newMember].sort((a, b) => b.seqnum - a.seqnum);
                }
                return validPrevMembers;

            } else {
                // 기존 멤버리스트의 추가메시지만 업뎃
                return validPrevMembers.map((member, index) => {
                    if (index === existingMemberIndex) {
                        return {
                            ...member,
                            mstMbNum: newMessage.mstMbNum,
                            mstUserNm: newMessage.mstUserNm,
                            seqnum: newMessage.seqnum,
                            // 💡 [중요] 현재 활성 채팅방이 아니고, 사용자가 보낸 메시지일 때만 카운트 증가
                            unreadCount: (String(newMessage.chatOrdNum) !== String(selectedOrderNumberRef.current) && isUserRole)
                                ? member.unreadCount + 1
                                : member.unreadCount,
                            chatKey: newMessage.chatKey,
                            regTime: newMessage.regTime,
                            memberDTO: newMessage.memberDTO
                        };
                    }
                    return member;
                }).sort((a, b) => b.seqnum - a.seqnum);
            }
        });

        // --- selectedUserOrderNumbers (주문서 목록) 업데이트 ---
        setSelectedUserOrderNumbers(prevOrderNumbers => {
            const validPrevOrderNumbers = Array.isArray(prevOrderNumbers) ? prevOrderNumbers : [];
            const updatedOrderNumbers = validPrevOrderNumbers.map(orderNumber => {
                if (orderNumber.chatOrdNum === newMessage.chatOrdNum) {
                    const isOrderRole = newMessage.memberDTO.role === '0';
                    return {
                        ...orderNumber,
                        seqnum: newMessage.seqnum,
                        // 💡 [중요] 현재 활성 채팅방이 아니고, 사용자가 보낸 메시지일 때만 카운트 증가
                        // (PC 버전의 newMessage.unreadCount를 사용하는 로직 대신, +1 증가 로직으로 통일 - 기존 모바일 로직)
                        unreadCount: (String(newMessage.chatOrdNum) !== String(selectedOrderNumberRef.current) && isOrderRole)
                            ? orderNumber.unreadCount + 1
                            : orderNumber.unreadCount,
                        chatKey: newMessage.chatKey
                    };
                }
                return orderNumber;
            });
            return updatedOrderNumbers.sort((a, b) => b.seqnum - a.seqnum);
        });
    };

    // 수신 후 현재 주문서채팅방 채팅메세지 업데이트용
    const onActiveOrderMessageReceived = async (payload) => {
        let newMessage = JSON.parse(payload.body);

        // ✅ 수신된 메시지의 주문서채팅방 식별값이 현재 채팅방 식별값과 다르면 chatMessages에 포함 X
        if (String(newMessage.chatOrdNum) !== String(selectedOrderNumberRef.current)) {
            return;
        }

        if (newMessage.chatKey.startsWith('chatFile')) {
            const filename = newMessage.chatKey.split('/').pop();
            if (isVideo(filename)) { newMessage.isVideo = true; }
            else if (isImage(filename)) { newMessage.isImage = true; }
            else { newMessage.isFile = true; }
        }

        setChatMessages(chatMessages => {
            const validChatMessages = Array.isArray(chatMessages) ? chatMessages : [];
            const isDuplicate = validChatMessages.some(message => message.seqnum === newMessage.seqnum);
            if (isDuplicate) return validChatMessages;
            // if (newMessage.memberDTO.role === "0") {
            //     return [...validChatMessages, newMessage];
            // }
            // return validChatMessages;

            // role에 상관없이 중복이 아니면 모두 추가 (관리자 A가 보낸 것을 관리자 B도 봐야 함)
            return [...validChatMessages, newMessage];
        });

        // 💡 [수정] 사용자가 보낸(role '0') 메시지일 때만 읽음 처리
        if (newMessage.chatOrdNum === selectedOrderNumberRef.current &&
            chatStartedRef.current &&
            newMessage.memberDTO.role === "0") {

            await handleChatMessages(newMessage); // 읽음처리 API
            await stompAdminRead(newMessage.chatOrdNum, newMessage.mstUserNm, newMessage.mstMbNum, newMessage.unreadCount); // 읽음처리전송
        }
    };

    // 다른 관리자가 주문서채팅 메세지를 읽었을 때 실행되는 함수
    const onAdminReadUpdateReceived = (payload) => {
        const readData = JSON.parse(payload.body);

        // 멤버리스트(memberList)의 통합 unreadCount 차감
        setMemberList(prevMembers => {
            const validMembers = Array.isArray(prevMembers) ? prevMembers : [];
            return validMembers.map(member => {
                // 회원 번호(mstMbNum)가 일치하는 경우
                if (String(member.mstMbNum) === String(readData.mstMbNum)) {
                    // 현재 개수에서 읽은 개수(readData.unreadCount)만큼 차감
                    const currentCount = member.unreadCount || 0;
                    const readCount = readData.unreadCount || 0;
                    const newCount = currentCount - readCount;

                    return {
                        ...member,
                        unreadCount: newCount < 0 ? 0 : newCount // 음수 방지
                    };
                }
                return member;
            });
        });

        // 하단 주문서리스트(selectedUserOrderNumbers)의 개별 unreadCount 초기화
        setSelectedUserOrderNumbers(prevOrderNumbers => {
            const validOrders = Array.isArray(prevOrderNumbers) ? prevOrderNumbers : [];
            return validOrders.map(chatDt => {
                // 해당 주문서만 unreadCount 초기화
                if (String(chatDt.chatOrdNum) === String(readData.chatOrdNum)) {
                    return {
                        ...chatDt,
                        unreadCount: 0
                    };
                }
                return chatDt;
            });
        });
    };

    const onChatAdminUpdate = ((payload) => {
        let adminUpdateData = JSON.parse(payload.body);

        // 💡 현재 활성화된 '주문서 채팅'일 때만 fetch
        if (adminUpdateData !== null &&
            chatStartedRef.current && // (chatStarted가 true일 때만)
            String(adminUpdateData) === String(selectedOrderNumberRef.current)) {

            fetchChatMessages(adminUpdateData);
        }
    });

    const formatDate = (dateString) => {
        let options = {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'};
        return new Date(dateString).toLocaleDateString(undefined, options)
    }

    const isImage = (fileName) => {
        const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "tiff", "webp"];
        const fileExtension = fileName.split('.').pop().toLowerCase();
        return imageExtensions.includes(fileExtension);
    }

    const isVideo = (filename) => {
        const extension = filename.split('.').pop().toLowerCase();
        return ['mp4', 'webm', 'ogg'].includes(extension);
    };

    const handleChatMessages = async (chat) => {
        try {
            await axios({
                method: 'post',
                url: `/order/chat/unread/`,
                params: {
                    chatOrdNum: chat.chatOrdNum,
                    userFl: false
                },
                headers: {
                    Authorization: LCAT
                }
            })
                .then(async () => {
                    await stompClient.send("/app/chat/totalCount", {}, JSON.stringify({sendFl: true}));
                    // chatDt 클릭 후 멤버상태변경
                    setMemberList((prevMembers) =>
                        prevMembers.map((member) => {
                            if (member.mstMbNum === chat.mstMbNum) {
                                return {
                                    ...member,
                                    unreadCount: member.unreadCount - chat.unreadCount,
                                };
                            }
                            return member;
                        })
                    );

                    // chatDt.unreadCount를 리셋
                    setSelectedUserOrderNumbers((prevChats) =>
                        prevChats.map((chatDt) => {
                            if (chatDt.seqnum === chat.seqnum) {
                                stompAdminRead(chatDt.chatOrdNum, chatDt.mstUserNm, chatDt.mstMbNum, chatDt.unreadCount);
                                return {
                                    ...chatDt,
                                    unreadCount: 0,
                                };
                            }
                            return chatDt;
                        })
                    );
                })
        } catch (error) {
            console.error(error);
        }
    };

    const oneMonthFromNow = (deadline) => {
        return deadline.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
    }

    function isSameDay(date1, date2) {
        return date1.getFullYear() === date2.getFullYear() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getDate() === date2.getDate();
    }

    function isFirstMessageOfDay(current, previous) {
        if (!previous) return true;
        const isSame = isSameDay(new Date(current.regTime), new Date(previous.regTime));
        return !isSame;
    }

    const formatTime = (timeString) => {
        return new Date(timeString).toTimeString().split(' ')[0];
    }

    const fetchChatMessages = async (chatOrdNum) => {
        if (!chatOrdNum) {
            return;
        }
        try {
            const response = await axios({
                method: 'get',
                url: '/order/chatFetch',
                headers: {
                    Authorization: LCAT
                },
                params: {
                    chatOrdNum: chatOrdNum
                }
            });
            if (!response || response.data === false) {
                console.log('데이터없음');
                return;
            }
            const data = response.data;

            for (let message of data) {
                if (message.chatKey.startsWith('chatFile')) {
                    const filename = message.chatKey.split('/').pop();
                    if (isVideo(filename)) {
                        message.fileUrl = "https://toeloperfile.s3.ap-northeast-2.amazonaws.com/ordChatMessage/" + message.chatKey;
                        message.isVideo = true;
                    } else if (isImage(filename)) {
                        message.fileUrl = "https://toeloperfile.s3.ap-northeast-2.amazonaws.com/ordChatMessage/" + message.chatKey;
                        message.isImage = true;
                    } else {
                        message.fileUrl = "file";
                    }
                }
            }
            setChatMessages(data);
            return data;
        } catch (error) {
            console.log("채팅페치오류 : ", error)
        }
    }

    useEffect(() => {
        fetchChatMessages(selectedOrderNumber && selectedOrderNumber)
            .then(data => setChatMessages(data))
            .catch(err => console.error(err));
    }, [selectedOrderNumber]);

    // 사용자 -> 관리자 읽음처리 수신
    const onReadMessageReceived = (payload) => {
        // 사용자가 읽었을 경우 관리자채팅 안읽은메시지수 0으로 초기화
        let userReadData = JSON.parse(payload.body);
        if (userReadData.readerRole === "USER" && chatStartedRef.current) {
            setChatMessages(currentChatMessages => {
                const updatedMessages = [...currentChatMessages];
                let hasUpdates = false;
                for (let message of updatedMessages) {
                    if (message.chatOrdNum === String(userReadData.chatOrdNum) && message.unreadCount > 0) {
                        message.unreadCount = 0;
                        hasUpdates = true;
                    }
                }
                return updatedMessages;
            })
        }
    };

    const stompAdminRead = (async (chatOrdNum, mstUserNm, mstMbNum, countToClear) => {
        if (!stompClient) {
            return;
        }
        // 관리자 -> 사용자 읽음전송
        if (chatStartedRef.current && chatOrdNum && mstUserNm) {
            const readChat = {
                chatOrdNum: chatOrdNum,
                mstMbNum: mstMbNum,
                mstUserNm: mstUserNm,
                readerRole: "ADMIN",
                unreadCount: countToClear
            };
            await stompClient.send("/app/chat/adminRead", {}, JSON.stringify(readChat));
        }
    });

    // const sendMessage = async (printFilename, originalFilename) => {
    //     if (stompClient && stompClient.connected && printFilename.trim() !== '') {
    //         if (selectedOrderNumber === null) {
    //             console.log("주문서가 선택되지 않았습니다.");
    //             return;
    //         }
    //         const chatMessage = {
    //             chatKey: printFilename,
    //             fileNm: originalFilename,
    //             chatOrdNum: selectedOrderNumber,
    //             mbNum: adminInfo.mbNum,
    //             mstMbNum: mstMbNum,
    //             mstUserNm: mstUserNm,
    //             memberDTO: adminInfo,
    //             sendMailFl: true,
    //             autoChatFl: false,
    //         };
    //         await stompClient.send("/app/chat/adminMessage", {}, JSON.stringify(chatMessage));
    //
    //         const newMessagePromise = new Promise((resolve) => {
    //             stompClient.subscribe(`/user/${mstMbNum}/queue/adminMessage`, (response) => {
    //                 const newMessage = JSON.parse(response.body);
    //                 resolve(newMessage);
    //             }, {id: `sub-${mstMbNum}`});
    //         });
    //
    //         // const newMessage = await newMessagePromise;
    //         // await new Promise(resolve => setTimeout(resolve, 500));
    //         // fetchChatMessages(chatMessage.chatOrdNum);
    //         // updateMemberAndOrderNumber(newMessage)
    //
    //         const newMessage = await newMessagePromise;
    //         updateMemberAndOrderNumber(newMessage)
    //
    //     } else {
    //         console.log("메시지전송 실패");
    //         await websocketConnect(adminInfo.mbNum);
    //         if (stompClient && stompClient.connected) {
    //             await sendMessage(printFilename, originalFilename);
    //         } else {
    //             console.log("웹소켓 연결에 실패하였습니다");
    //         }
    //     }
    // };

    const handleSendProcess = async () => {
        if (isSending || typeof message !== 'string' || message.trim() === '') return;

        const backupMessage = message;
        setIsSending(true); // 버튼 및 텍스트에리어 락 활성화
        setMessage(''); // 입력창 비우기
        chatScrollBottom(true); // 내가 보낸 직후에는 최신으로

        const now = new Date();
        const yyyymmdd = now.toISOString().slice(0, 10).replace(/-/g, '');
        const formattedTime = now.toTimeString().split(' ')[0];

        // 관리자가 보낸 메시지(role: '1') 형태로 페이크 버블 빌드
        const tempSeqnum = Date.now();
        const tempLoadingMsg = {
            seqnum: tempSeqnum,
            chatKey: backupMessage,
            fileNm: null,
            isPending: true, // 👈 UI에서 도트 로딩을 활성화하는 키
            regDate: yyyymmdd,
            regTime: `0000-00-00 ${formattedTime}`,
            memberDTO: { role: '1' },
            mstUserNm: 'Btorage'
        };

        // 화면 최하단에 즉시 노출
        setChatMessages(prev => [...(Array.isArray(prev) ? prev : []), tempLoadingMsg]);

        try {
            // 기존의 sendMessage 함수를 그대로 활용
            const isSuccess = await sendMessage(backupMessage, '');
            if (isSuccess) {
                // 성공 시 가짜 버블 제거 (진짜 메시지는 비동기 동기화 구문이 대체함)
                setChatMessages(prev => prev.filter(msg => msg.seqnum !== tempSeqnum));
                if (chatInputRef.current) chatInputRef.current.style.height = '42px';
            } else {
                setChatMessages(prev => prev.filter(msg => msg.seqnum !== tempSeqnum));
                setMessage(backupMessage);
                alert("메시지 전송에 실패했습니다. 네트워크 상태를 확인하시거나 화면을 새로고침해주세요.");
            }
        } catch (error) {
            setChatMessages(prev => prev.filter(msg => msg.seqnum !== tempSeqnum));
            setMessage(backupMessage);
        } finally {
            setIsSending(false); // 가드 해제
        }
    };

    const sendMessage = async (printFilename, originalFilename) => {
        if (selectedOrderNumber === null) {
            console.log("주문서가 선택되지 않았습니다.");
            return false;
        }

        if (stompClient && stompClient.connected && printFilename.trim() !== '') {
            return await executeSend(stompClient, printFilename, originalFilename);
        } else {
            console.log("메시지전송 실패, 재연결 시도 중...");
            try {
                const activeClient = await websocketConnect(adminInfo.mbNum);
                if (activeClient && activeClient.connected) {
                    return await executeSend(activeClient, printFilename, originalFilename);
                }
            } catch (error) {
                console.error("재연결 에러:", error);
            }
            console.log("웹소켓 연결에 실패하였습니다");
            return false;
        }
    };

    const executeSend = async (client, printFilename, originalFilename) => {
        const chatMessage = {
            chatKey: printFilename,
            fileNm: originalFilename,
            chatOrdNum: selectedOrderNumber,
            mbNum: adminInfo.mbNum,
            mstMbNum: mstMbNum,
            mstUserNm: mstUserNm,
            memberDTO: adminInfo,
            sendMailFl: true,
            autoChatFl: false,
        };
        await client.send("/app/chat/adminMessage", {}, JSON.stringify(chatMessage));

        const newMessagePromise = new Promise((resolve) => {
            client.subscribe(`/user/${mstMbNum}/queue/adminMessage`, (response) => {
                const newMessage = JSON.parse(response.body);
                resolve(newMessage);
            }, {id: `sub-${mstMbNum}`});
        });

        const newMessage = await newMessagePromise;
        updateMemberAndOrderNumber(newMessage);
        return true;
    };

    // 주문서채팅 좌측 멤버리스트 업데이트용
    const updateMemberAndOrderNumber = ((newMessage) => {
        setChatMessages(chatMessages => {
            const validChatMessages = Array.isArray(chatMessages) ? chatMessages : [];
            // 중복 메시지 체크
            const isDuplicate = validChatMessages.some(message => message.seqnum === newMessage.seqnum);
            if (isDuplicate) return validChatMessages;
            return [...validChatMessages, newMessage];
        });

        setMemberList(prevMembers => {
            const validPrevMembers = Array.isArray(prevMembers) ? prevMembers : [];
            let existingMemberIndex = validPrevMembers.findIndex(member => String(member.mstMbNum) === String(newMessage.mstMbNum));
            const isUserRole = newMessage.memberDTO && newMessage.memberDTO.role === '0';

            if (existingMemberIndex === -1) {
                const newMember = {
                    mstMbNum: newMessage.mstMbNum,
                    mstUserNm: newMessage.mstUserNm,
                    seqnum: newMessage.seqnum,
                    unreadCount: isUserRole ? 1 : 0,
                    chatKey: newMessage.chatKey,
                    regTime: newMessage.regTime,
                    memberDTO: newMessage.memberDTO
                };
                return [...validPrevMembers, newMember].sort((a, b) => b.seqnum - a.seqnum);
            } else {
                return validPrevMembers.map((member, index) => {
                    if (index === existingMemberIndex) {
                        return {
                            ...member,
                            mstMbNum: newMessage.mstMbNum,
                            mstUserNm: newMessage.mstUserNm,
                            seqnum: newMessage.seqnum,
                            unreadCount: member.unreadCount, // 관리자가 보낸 메시지이므로 카운트 증가 안함
                            chatKey: newMessage.chatKey,
                            regTime: newMessage.regTime,
                            memberDTO: newMessage.memberDTO
                        };
                    }
                    return member;
                }).sort((a, b) => b.seqnum - a.seqnum);
            }
        });

        setSelectedUserOrderNumbers(prevOrderNumbers => {
            const validPrevOrderNumbers = Array.isArray(prevOrderNumbers) ? prevOrderNumbers : [];
            const updatedOrderNumbers = validPrevOrderNumbers.map(orderNumber => {
                if (orderNumber.chatOrdNum === newMessage.chatOrdNum) {
                    return {
                        ...orderNumber,
                        seqnum: newMessage.seqnum,
                        unreadCount: orderNumber.unreadCount, // 관리자가 보낸 메시지이므로 카운트 증가 안함
                        chatKey: newMessage.chatKey
                    };
                }
                return orderNumber;
            });
            return updatedOrderNumbers.sort((a, b) => b.seqnum - a.seqnum);
        });
    });

    const handleFileUpload = (event) => {
        if (event.target.files.length > 0) {
            const file = event.target.files[0];
            setSelectedFile(file);
            setSelectedFileUrl(URL.createObjectURL(file));
        }
    };

    const messagesEndRef = useRef(null);


    /*
     * [스크롤 유지] 주문서채팅
     *  바닥 근처(80px 이내)를 보고 있을 때만 새 메세지를 따라 내려간다.
     *  위 내용을 읽는 중이면 그대로 둔다.
     */
    const messagesEndRefStickRef = useRef(true);

    // 방을 바꾸면 주문서채팅은 다시 최신 메세지부터 보여준다
    useEffect(() => {
        messagesEndRefStickRef.current = true;
    }, [selectedOrderNumber]);

    const handleMessagesEndRefScroll = () => {
        const el = messagesEndRef.current;
        if (!el) return;
        messagesEndRefStickRef.current = el.scrollHeight - el.scrollTop - el.clientHeight < 80;
    };

    /** @param force true 면 스크롤 위치와 무관하게 바닥으로 (최초진입 / 내가 보냈을 때) */
    const chatScrollBottom = (force) => {
        if (force) messagesEndRefStickRef.current = true;
        // 위 내용을 읽는 중이면(바닥에서 떨어져 있으면) 끌어내리지 않는다
        if (!messagesEndRefStickRef.current) return;
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollTo({
                top: messagesEndRef.current.scrollHeight,
                behavior: 'smooth',
            });
        }
    };

    const chatInputRef = React.useRef(null);
    const ordChatMaxTextAreaHeight = 132; // 최대 높이 (약 6줄 — CSS max-height 와 같은 값)
    const ORD_CHAT_TEXTAREA_MIN = 42;     // 한 줄 높이

    /*
     * 입력창 높이만 내용에 맞춘다.
     *
     *  [기존 문제]
     *   여기서 메세지목록(chatBody)의 높이까지 calc(81.5% - Npx) 로 직접 계산했다.
     *   그래서 전송 후 값이 원래대로 돌아오지 않으면 입력창이 화면 중간에 뜨고,
     *   매크로로 여러 줄을 넣으면 계산이 어긋나 입력창이 화면 밖으로 밀렸다.
     *
     *  [지금]
     *   화면이 세로 flex 이고 목록이 flex:1 / min-height:0 이라
     *   입력창이 커지면 목록이 알아서 줄어든다. 높이를 계산할 필요가 없다.
     *   (CSS : MAdminOrderChatPg.css 하단 '채팅화면 레이아웃' 블록)
     */
    const resizeTextArea = () => {
        const textArea = chatInputRef.current;
        if (!textArea) return;

        const wasAtBottom = messagesEndRefStickRef.current;

        // 줄어들 때도 맞추려면 먼저 초기화한 뒤 실제 내용높이를 읽어야 한다
        textArea.style.height = `${ORD_CHAT_TEXTAREA_MIN}px`;
        const newHeight = Math.min(
            Math.max(textArea.scrollHeight, ORD_CHAT_TEXTAREA_MIN),
            ordChatMaxTextAreaHeight,
        );
        textArea.style.height = `${newHeight}px`;

        // 입력창이 커진 만큼 목록이 줄어든다. 바닥을 보고 있었다면 그대로 바닥을 유지한다.
        if (wasAtBottom) chatScrollBottom(true);
    };

    const [fileSizeOverSt, setFileSizeOverSt] = useState(false);
    const closeFileSizeOverSt = (() => {
        setFileSizeOverSt(false);
    })

    const handleChatInput = (e) => {
        setMessage(e.target.value);
    };

    /*
     * 높이 계산은 값이 실제로 그려진 뒤(useEffect)에 해야 한다.
     *  - onChange 안에서 재면 그 시점의 textarea 에는 아직 새 내용이 없어 한 글자 늦는다.
     *  - 매크로처럼 값을 '코드로' 넣으면 onChange 자체가 없어 아예 반영되지 않았다.
     *  - if (message) 로 감싸면 전송 후 빈 값이 되었을 때 초기화가 되지 않아
     *    입력창이 여러 줄 높이 그대로 남아있었다. 조건 없이 항상 다시 맞춘다.
     */
    useEffect(() => {
        resizeTextArea();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [message]);

    useEffect(() => {
        if (messagesEndRefStickRef.current) chatScrollBottom();
    }, [chatMessages]);


    const saveChatFile = async () => {
        if (!selectedFile || !selectedFile.size) {
            setShowChatFile(false);
            return;
        }
        const MAX_FILE_SIZE = 128 * 1024 * 1024; // 최대파일크기 128MB(백엔드에 맞추기)
        if (selectedFile.size > MAX_FILE_SIZE) {
            setShowChatFile(false);
            resetFileInput();
            setFileSizeOverSt(true);
            return;
        }
        const formData = new FormData();
        formData.append('file', selectedFile);
        axios({
            method: 'post',
            url: '/order/upload',
            headers: {
                Authorization: LCAT
            },
            data: formData
        })
            .then(async (response) => {
                const fileKeys = response.data;
                await sendMessage(fileKeys.printFilename, fileKeys.originalFilename);
                setChatStarted(true);
                setShowChatFile(false);
                resetFileInput();
            })
    };

    const downloadFile = async (filename, originalFilename, type) => {
        const response = await axios({
            method: 'get',
            url: `/order/chatFileDownload/${filename}`,
            params: {
                type: type
            },
            responseType: 'blob',
        });
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', originalFilename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        setSelectedClickSt(false);
        openDownloadFileCompl();
    };

    const [downloadFileComplSt, setDownloadFileComplSt] = useState(false);
    const openDownloadFileCompl = (() => {
        setDownloadFileComplSt(true);
    })
    const closeDownloadFileCompl = (() => {
        setDownloadFileComplSt(false);
    })

    const showChatFileClose = (() => {
        setShowChatFile(false);
        resetFileInput();
    })

    const triggerFileInput = () => {
        fileInputRef.current.click();
        setShowChatFile(true);
    };

    const resetFileInput = () => {
        fileInputRef.current.value = "";
        setSelectedFile(null);
        setSelectedFileUrl(null);
    };

    const handleEmojiClick = (emoji) => {
        const newMessage = message + emoji.native;
        setMessage(newMessage);
        setShowEmoji(false);
    };

    const handleUpload = (event) => {
        event.preventDefault();
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
    };

    const [chatModifySt, setChatModifySt] = useState(false)
    const [chatFileModifySt, setChatFileModifySt] = useState(false)
    const [messageToModify, setMessageToModify] = useState(null);

    const chatModifyFalseFn = (() => {
        setChatModifySt(false);
    })
    const chatFileModifyFalseFn = (() => {
        setChatFileModifySt(false);
    })

    const openModifyModal = (message) => {
        setMessageToModify(message);
        if (message.chatKey.startsWith("chatFile")) {
            setChatFileModifySt(true);
        } else {
            setChatModifySt(true);
        }
    };

    const updateChatMessage = (modifiedMessage) => {
        const index = chatMessages.findIndex(msg => msg.seqnum === modifiedMessage.seqnum);
        const updatedChatMessages = [...chatMessages];
        updatedChatMessages[index] = modifiedMessage;
        setChatMessages(updatedChatMessages);
    };

    const chatFileModify = (changeFile, changeData) => {

        if (changeData.chatKey.startsWith('chatFile')) {
            // Handle the case where changeFile is a file
            const formData = new FormData();
            formData.append('changeFile', changeFile);
            formData.append('seqnum', changeData.seqnum);
            axios({
                method: 'post',
                url: '/order/chatFileModify/',
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: LCAT
                },
            })
                .then(async (response) => {
                    const data = response.data;
                    const userInfo = {
                        userMbNum: data.mstMbNum,
                        userName: data.userName,
                        keyNumber: data.chatOrdNum,
                        sendFl: true
                    };
                    await updateChatMessage(response.data)
                    await onModifyMessageUpdate(response.data)
                    await stompClient.send("/app/chat/modifyMessage", {}, JSON.stringify(userInfo));
                    setChatFileModifySt(false);
                })
        } else {
            axios({
                method: 'post',
                url: '/order/chatFileModify/',
                params: {
                    seqnum: changeData.seqnum
                },

                data: changeFile,

                headers: {
                    'Content-Type': 'text/plain',
                    Authorization: LCAT
                },
            })
                .then(async (response) => {
                    const data = response.data;
                    const userInfo = {
                        userMbNum: data.mstMbNum,
                        userName: data.userName,
                        keyNumber: data.chatOrdNum,
                        sendFl: true
                    };
                    await updateChatMessage(response.data)
                    await onModifyMessageUpdate(response.data)
                    await stompClient.send("/app/chat/modifyMessage", {}, JSON.stringify(userInfo));
                    setChatModifySt(false);
                })
        }
    };

    const onModifyMessageUpdate = ((modifyMessage) => {
        // 멤버리스트 채팅데이터 업뎃
        setMemberList(prevMembers => prevMembers.map(member => {
            if (member.mstMbNum === modifyMessage.mstMbNum) {
                return {
                    ...member,
                    ...modifyMessage,
                };
            }
            return member;
        }));

        // 오더리스트 채팅데이터 업뎃
        setSelectedUserOrderNumbers(prevOrderNumbers => prevOrderNumbers.map(orderNumber => {
            if (orderNumber.chatOrdNum === modifyMessage.chatOrdNum) {
                return {
                    ...orderNumber,
                    ...modifyMessage,
                };
            }
            return orderNumber;
        }));
    })

    const [chatDeleteSt, setChatDeleteSt] = useState(false);
    const chatDeleteFalseFn = (() => {
        setChatDeleteSt(false);
    })
    const chatDeleteMsg1 = "해당 채팅메시지를 삭제하시겠습니까?"
    const chatDeleteMsg2 = "삭제 시 복구가 불가능합니다"

    const openDeleteModal = ((chatData) => {
        if (chatData !== null) {
            setMessageToModify(chatData);
        }
        setChatDeleteSt(true);
    })

    const deleteChat = ((deleteMessage) => {
        axios({
            method: 'post',
            url: '/order/deleteChat/',
            params: {
                seqnum: deleteMessage.seqnum
            },
            headers: {
                Authorization: LCAT
            },
        })
            .then(async () => {
                const userInfo = {
                    userMbNum: deleteMessage.mstMbNum,
                    userName: deleteMessage.userName,
                    keyNumber: deleteMessage.chatOrdNum,
                    sendFl: true
                };
                await setChatMessages((prevChatMessages) => prevChatMessages.filter(message => message.seqnum !== deleteMessage.seqnum));
                await selectAllChatList();
                await selectedOrderNumbers(deleteMessage.mstMbNum);
                await stompClient.send("/app/chat/deleteMessage", {}, JSON.stringify(userInfo));
                setChatDeleteSt(false);
            })
    })

    const [selectedClickFile, setSelectedClickFile] = useState(null);
    const [selectedClickSt, setSelectedClickSt] = useState(false);
    const clickFileDetail = ((file) => {
        setSelectedClickFile(file);
        setSelectedClickSt(true);
    })
    const clickFileClose = (() => {
        setSelectedClickSt(false);
    })

    //endregion

    useEffect(() => {
        defaultMonth();
    }, []);

    useEffect(() => {
        if (startDate && endDate) {
            selectAllChatList();
        }
    }, [startDate, endDate]);

    const selectAllChatList = (() => {
        axios({
            method: 'get',
            url: '/order/selectAllChatList',
            headers: {
                Authorization: LCAT
            },
            params: {
                startDate: stringStartDate,
                endDate: stringEndDate,
            },
        })
            .then((response) => {
                const sortedData = response.data.sort((a, b) => b.seqnum - a.seqnum);
                setMemberList(sortedData)
            })
            .catch(() => {
                console.log("실패")
            })
    })

    const [ordChat, setOrdChat] = useState(true);
    const [nonMember, setNonMember] = useState(false);
    // [구매대행 API] 상점사 채팅탭
    const [storeChat, setStoreChat] = useState(false);
    const [autoRes, setAutoRes] = useState(false);
    const [macro, setMacro] = useState(false);

    const handleTab = ((state) => {
        if (state === 'ordChat') {
            setOrdChat(true);
            setNonMember(false);
            setStoreChat(false);
            setChatStarted(false);
            setNonChatShow(false);
        } else if (state === 'nonMember') {
            setOrdChat(false);
            setNonMember(true);
            setStoreChat(false);
            setChatStarted(false);
            setNonChatShow(false);
        } else if (state === 'storeChat') {
            // [구매대행 API] 상점사 채팅탭
            setOrdChat(false);
            setNonMember(false);
            setStoreChat(true);
            setChatStarted(false);
            setNonChatShow(false);
        }
    })

    /**
     * [구매대행 API] 채팅탭 헤더
     *  - 상단 한 줄에 [주문서] / [비회원] / [상점사] 탭을 배치한다.
     *  - 각 탭 문구 우측에는 채팅종류별 안읽은 메세지 총합을 출력한다.
     *  - Search 인풋은 renderChatSearch 로 분리했다.
     *    탭 바로 아래가 아니라 조회날짜 아래에 두어야 좌우 끝선이 맞기 때문이다.
     */
    const renderChatTabs = () => (
        <div className="m-a-chatTab-container font-t-title"
             style={{display: "flex", flexDirection: "column", alignItems: "stretch", gap: "10px"}}>
            <div className="user-center" style={{display: "flex", justifyContent: "center", flexWrap: "wrap", gap: "8px"}}>
                <div onClick={() => handleTab("ordChat")}
                     className={ordChat ? "m-a-headerFocusTab" : "m-a-headerTab"}>
                    <div className="font-s-14">주문서</div>
                    <div className="font-t-cont chatTtCt m-l-3"
                         style={{color: !ordChat ? "#FF6324" : "white"}}>{lcOrdChatCount}</div>
                </div>
                <div onClick={() => handleTab("nonMember")}
                     className={nonMember ? "m-a-headerFocusTab" : "m-a-headerTab"}>
                    <div className="font-s-14">비회원</div>
                    <div className="font-t-cont chatTtCt m-l-3"
                         style={{color: !nonMember ? "#FF6324" : "white"}}>{lcNUserChatCount}</div>
                </div>
                <div onClick={() => handleTab("storeChat")}
                     className={storeChat ? "m-a-headerFocusTab" : "m-a-headerTab"}>
                    <div className="font-s-14">상점사</div>
                    <div className="font-t-cont chatTtCt m-l-3"
                         style={{color: !storeChat ? "#FF6324" : "white"}}>{lcStoreChatCount}</div>
                </div>
            </div>
        </div>
    );

    /*
     * Search 인풋
     *  탭 바로 아래가 아니라 조회날짜 아래에 둔다.
     *  조회날짜와 좌우 끝선을 맞춰 한 줄을 온전히 쓰도록 폭을 100% 로 유지한다.
     *  (예전에는 탭 안에 들어있고 max-width:45% 라 절반만 차지한 채 혼자 튀어나와 보였다)
     */
    const renderChatSearch = (searchValue, onSearchChange) => (
        <div className="m-a-card-shadow m-a-input-frame ht-45 m-a-chat-search-container m-t-10">
            <input type="text" className="m-a-input font-t-cont" placeholder="Search"
                   value={searchValue} onChange={onSearchChange}
                   style={{borderRadius: "10px"}}/>
        </div>
    );

    // 비회원채팅 시작
    const [selectNonMemberDate, setSelectNonMemberDate] = useState("1주일");

    const [showNonEmoji, setShowNonEmoji] = useState(false);
    const [nonMessage, setNonMessage] = useState('');
    const [nonChatShow, setNonChatShow] = useState(false);

    /*
     * ── 디바이스 키보드 대응 ────────────────────────────────────────────────
     *  모바일에서 입력창을 누르면 키보드가 올라오는데, iOS 는 이때 100vh 를 줄이지 않아
     *  height:100vh 로 잡아둔 채팅화면의 입력창이 키보드 뒤로 숨어버린다.
     *  실제로 보이는 높이(--app-vvh)를 CSS 변수로 심어 화면높이로 쓰면
     *  어느 기기에서든 입력창이 키보드 바로 위에 붙는다.
     *
     *  키보드가 뜨고 질 때마다 보이는 높이가 바뀌므로,
     *  바닥을 보고 있었다면 최신 메세지가 계속 보이도록 위치를 다시 맞춘다.
     *  (위 내용을 읽는 중이면 건드리지 않는다)
     */
    const handleChatViewportResize = () => {
        if (chatStarted && messagesEndRefStickRef.current) chatScrollBottom(true);
        if (nonChatShow && nonMessagesEndRefStickRef.current) nonChatScrollBottom(true);
    };

    useVisualViewportVars(chatStarted || nonChatShow, handleChatViewportResize);
    const [nonMemberList, setNonMemberList] = useState([]);
    const [nonChatMessages, setNonChatMessages] = useState([]);
    const [nonSelectedFileUrl, setNonSelectedFileUrl] = useState(null);
    const [nonSelectedFile, setNonSelectedFile] = useState(null);
    const [nonShowChatFile, setNonShowChatFile] = useState(false);

    const [nonSelectedMacroMstIndex, setNonSelectedMacroMstIndex] = useState(null);

    const nonFileInputRef = useRef();

    const selectNonMemberMsg = (() => {
        axios({
            method: 'get',
            url: '/member/selectNonMemberMsg',
            headers: {
                Authorization: LCAT
            },
            params: {
                dateParam: selectNonMemberDate
            },
        })
            .then((response) => {
                const sortedData = response.data.sort((a, b) => b.seqnum - a.seqnum);
                setNonMemberList(sortedData)
            })
            .catch(() => {
                console.log("실패")
            })
    })

    const selectNonMacroList = () => axios({
        method: 'get',
        url: '/member/selectMacroList/',
        headers: {
            Authorization: LCAT
        },
    })
        .then((response) => {
            setMacroMstList(response.data)
        })

    useEffect(() => {
        if (nonMember || ordChat) {
            selectNonMacroList();
        }
    }, [nonMember, ordChat]);

    const [nonSearchInput, setNonSearchInput] = useState('');
    const nonHandleSearchInputChange = (event) => {
        setNonSearchInput(event.target.value);
    };
    const filteredNonMemberList = nonMemberList.filter((nonMember) => {
        if (!nonSearchInput) return true; // 검색어 없으면 전체 표시

        const keyword = nonSearchInput.toLowerCase();
        // 고객 이름 검색
        const nameMatch = nonMember.msgNum && nonMember.msgNum.toLowerCase().includes(keyword);
        // 채팅 내용(마지막 대화) 검색
        const contentMatch = nonMember.chatKey && nonMember.chatKey.toLowerCase().includes(keyword);

        return nameMatch || contentMatch;
    });

    const fetchNonMacroDtList = ((index) => {
        if (nonSelectedMacroMstIndex === index) {
            setNonSelectedMacroMstIndex(null);
            setMacroDtList([]);
        } else {
            setNonSelectedMacroMstIndex(index);
            setMacroDtList(macroMstList[index].macroDt);
        }
    })

    const sendNonMacroMessage = (content) => {
        if (nonChatShow) {
            setNonMessage(content)
            setIsMacroPopupVisible(false);
        }
    }

    const sendOrdMacroMessage = (content) => {
        if (chatStarted) {
            setMessage(content)
            setIsMacroPopupVisible(false);
        }
    }

    // 관리자 비회원채팅 응대
    const nonSelectedOrderNumberRef = useRef(sendMsgNum);
    const nonChatShowRef = useRef(nonChatShow);
    const nonMemberListRef = useRef(nonMemberList);
    const nonChatMessagesRef = useRef(nonChatMessages);

    useEffect(() => {
        nonSelectedOrderNumberRef.current = sendMsgNum;
        nonChatShowRef.current = nonChatShow;
        nonMemberListRef.current = nonMemberList
        nonChatMessagesRef.current = nonChatMessages
    }, [sendMsgNum, nonChatShow, nonMemberListRef, nonChatMessages]);

    // 비회원채팅 좌측 멤버리스트 업데이트용
    const onNonMemberListUpdateReceived = (payload) => {
        let newMessage = JSON.parse(payload.body);
        const isUserRole = newMessage.role === "1";

        if (newMessage.chatKey.startsWith('chatFile')) {
            const filename = newMessage.chatKey.split('/').pop();
            if (isVideo(filename)) { newMessage.isVideo = true; }
            else if (isImage(filename)) { newMessage.isImage = true; }
            else { newMessage.isFile = true; }
        }

        setNonMemberList(currentList => {
            const validCurrentList = Array.isArray(currentList) ? currentList : [];
            const matchingIndex = validCurrentList.findIndex(item => item.msgNum === newMessage.msgNum);

            if (matchingIndex !== -1) {
                // --- 1. 기존 채팅방 업데이트 ---
                const updatedList = [...validCurrentList];
                const currentItem = updatedList[matchingIndex];
                updatedList[matchingIndex] = {
                    ...currentItem,
                    chatKey: newMessage.chatKey,
                    regTime: newMessage.regTime,
                    seqnum: newMessage.seqnum,
                    role: newMessage.role,
                    // 💡 [버그 수정] (PC와 동일한 로직)
                    unreadCount: (String(newMessage.msgNum) !== String(nonSelectedOrderNumberRef.current) && isUserRole)
                        ? (currentItem.unreadCount + 1)
                        : currentItem.unreadCount
                };
                return updatedList.sort((a, b) => b.seqnum - a.seqnum);

            } else {
                // --- 2. 새 채팅방 추가 ---
                if (isUserRole) {
                    const newItem = { ...newMessage, unreadCount: 1 };
                    // 💡 새 채팅방이므로 selectNonMemberMsg()를 다시 호출하여 목록을 갱신 (기존 모바일 로직)
                    selectNonMemberMsg(); // (이 함수가 목록을 다시 불러오므로 아래 return은 즉각 반영용)
                    return [...validCurrentList, newItem].sort((a, b) => b.seqnum - a.seqnum);
                }
                return validCurrentList;
            }
        });
    };

    // 수신 후 현재 비회원채팅방 채팅메세지 업데이트용
    const onActiveNonMemberMessageReceived = async (payload) => {
        let newMessage = JSON.parse(payload.body);

        // ✅ 수신된 메시지의 채팅방 식별값이 현재 채팅방 식별값과 다르면 chatMessages에 포함 X
        if (String(newMessage.msgNum) !== String(nonSelectedOrderNumberRef.current)) {
            return;
        }

        if (newMessage.chatKey.startsWith('chatFile')) {
            const filename = newMessage.chatKey.split('/').pop();
            if (isVideo(filename)) { newMessage.isVideo = true; }
            else if (isImage(filename)) { newMessage.isImage = true; }
            else { newMessage.isFile = true; }
        }

        setNonChatMessages(chatMessages => {
            const validChatMessages = Array.isArray(chatMessages) ? chatMessages : [];
            const newChatMessages = [...validChatMessages, newMessage];
            newChatMessages.sort((a, b) => a.seqnum - b.seqnum);
            return newChatMessages;
        });

        if (String(newMessage.msgNum) === String(nonSelectedOrderNumberRef.current) && nonChatShowRef.current) {
            // 읽음 처리 (비회원(role-1)이 보낸 메시지만)
            if (newMessage.unreadCount > 0 && newMessage.role === "1") {
                try {
                    await axios({
                        method: 'post',
                        url: `/member/chat/unread/`,
                        params: { msgNum: newMessage.msgNum },
                        headers: { Authorization: LCAT }
                    });
                    if (stompClient) {
                        await stompClient.send("/app/chat/totalCount", {}, JSON.stringify({sendFl: true}));
                    }
                    nonStompAdminRead(newMessage.msgNum);

                    // 좌측 목록(nonMemberList)의 안읽은 카운트 0으로 즉시 갱신
                    setNonMemberList(prevNonMemberList => {
                        const validPrevList = Array.isArray(prevNonMemberList) ? prevNonMemberList : [];
                        return validPrevList.map(item => {
                            if (String(newMessage.msgNum) === String(item.msgNum)) {
                                return {...item, unreadCount: 0};
                            }
                            return item;
                        });
                    });

                } catch (error) {
                    console.error("비회원 채팅 읽음 처리 API 호출 실패:", error);
                }
            }
        }
    };

    useEffect(() => {
        selectNonMemberMsg();
    }, [selectNonMemberDate])

    const nonDownloadFile = async (filename, originalFilename, type) => {
        const response = await axios({
            method: 'get',
            url: `/member/chatFileDownload/${filename}`,
            responseType: 'blob',
            params: {
                type: type
            },
        });
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', originalFilename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        setNonSelectedClickSt(false);
        openDownloadFileCompl();
    };

    const handleNonChatMessages = async (chat) => {
        setSendMsgNum(chat.msgNum)
        setNonChatShow(true);
        // 주문서 채팅상태 닫기
        setChatStarted(false);
        setSelectedOrderNumber(null);
        if (chat.unreadCount > 0 && chat.role === "1") {
            await axios({
                method: 'post',
                url: `/member/chat/unread/`,
                params: {
                    msgNum: chat.msgNum,
                },
                headers: {
                    Authorization: LCAT
                }
            })
                .then(async () => {
                    await stompClient.send("/app/chat/totalCount", {}, JSON.stringify({sendFl: true}));
                    setNonMemberList(prevNonMemberList => {
                        return prevNonMemberList.map(item => {
                            if (chat.msgNum === item.msgNum) {
                                nonStompAdminRead(chat.msgNum);
                                return {...item, unreadCount: 0};
                            }
                            return item;
                        });
                    });
                })
                .catch(error => console.error(error));
        }
    }

    const nonFetchChatMessages = async (msgNum, sendFl) => {
        if (!msgNum) {
            return;
        }
        try {
            const response = await axios({
                method: 'get',
                url: '/member/chatFetch',
                params: {
                    msgNum: msgNum
                }
            });
            if (!response || response.data === false) {
                console.log('데이터없음');
                return;
            }
            const data = response.data;
            // data.sort((a, b) => b.seqnum - a.seqnum);

            for (let nonMessage of data) {
                if (nonMessage.chatKey.startsWith('chatFile')) {
                    const filename = nonMessage.chatKey.split('/').pop();
                    if (isVideo(filename)) {
                        nonMessage.fileUrl = "https://toeloperfile.s3.ap-northeast-2.amazonaws.com/nUserChatMsg/" + nonMessage.chatKey;
                        nonMessage.isVideo = true;
                    } else if (isImage(filename)) {
                        nonMessage.fileUrl = "https://toeloperfile.s3.ap-northeast-2.amazonaws.com/nUserChatMsg/" + nonMessage.chatKey;
                        nonMessage.isImage = true;
                    } else {
                        nonMessage.fileUrl = "file";
                    }
                }
            }

            // 현재 선택된 좌측 nonMemberList 채팅메시지를 newMessage로 업데이트
            setNonMemberList(currentList => {
                const matchingIndex = currentList.findIndex(item => item.msgNum === msgNum);
                if (matchingIndex !== -1) {
                    const updatedMessage = {...data[data.length - 1], unreadCount: 0};
                    const updatedList = [...currentList];
                    updatedList[matchingIndex] = updatedMessage;
                    updatedList.sort((a, b) => b.seqnum - a.seqnum);
                    return updatedList;
                }
                return currentList;
            });

            setNonChatMessages(data);
            return data;
        } catch (error) {
            console.log("채팅페치오류 : ", error)
        }
    }

    useEffect(() => {
        if (sendMsgNum) {
            nonFetchChatMessages(sendMsgNum && sendMsgNum)
                .then(data => setNonChatMessages(data))
                .catch(err => console.error(err));
        }
    }, [sendMsgNum]);

    // 사용자 -> 관리자 읽음수신 코드
    const nonOnReadMessageReceived = (payload) => {
        // 사용자가 읽었을 경우 관리자채팅 안읽은메시지 수 '0'으로 초기화
        let userReadData = JSON.parse(payload.body);
        if (userReadData && userReadData.readerRole === "USER") {
            setNonChatMessages(currentChatMessages => {
                const updatedMessages = [...currentChatMessages];
                let hasUpdates = false;
                for (let nonMessage of updatedMessages) {
                    if (nonMessage.msgNum === String(userReadData.msgNum) && nonMessage.unreadCount > 0) {
                        nonMessage.unreadCount = 0;
                        hasUpdates = true;
                    }
                }
                return updatedMessages;
            })
        }
    };

    // 다른 관리자가 비회원채팅 메세지를 읽었을 때 실행되는 함수
    const nonOnAdminReadUpdateReceived = (payload) => {
        const readData = JSON.parse(payload.body);

        // 비회원 채팅 목록(nonMemberList) 업데이트 -> 해당 채팅방의 안읽음 뱃지를 0으로 초기화
        setNonMemberList(currentList => {
            const validList = Array.isArray(currentList) ? currentList : [];
            return validList.map(item => {
                // 메세지 식별번호(msgNum)가 일치하는 경우
                if (String(item.msgNum) === String(readData.msgNum)) {
                    return { ...item, unreadCount: 0 };
                }
                return item;
            });
        });
    };

    // const nonSendMessage = async (printFilename, originalFilename, msgNum) => {
    //     if (stompClient && stompClient.connected && printFilename.trim() !== '') {
    //         const nonChatMessage = {
    //             chatKey: printFilename,
    //             fileNm: originalFilename,
    //             msgNum: msgNum,
    //             role: '0',
    //             autoFl: false
    //         };
    //         await stompClient.send("/app/nonUserChat/adminMessage", {}, JSON.stringify(nonChatMessage));
    //         await new Promise(resolve => setTimeout(resolve, 500));
    //         nonFetchChatMessages(msgNum, true);
    //     } else {
    //         console.log("메시지전송 실패");
    //         await websocketConnect(msgNum);
    //         if (stompClient && stompClient.connected) {
    //             await sendMessage(printFilename, originalFilename, msgNum);
    //         } else {
    //             console.log("웹소켓 연결에 실패하였습니다");
    //         }
    //     }
    // };

    const nonSendMessage = async (printFilename, originalFilename, msgNum) => {
        if (stompClient && stompClient.connected && printFilename.trim() !== '') {
            return await executeNonSend(stompClient, printFilename, originalFilename, msgNum);
        } else {
            console.log("메시지전송 실패, 재연결 시도 중...");
            try {
                const activeClient = await websocketConnect(msgNum);
                if (activeClient && activeClient.connected) {
                    return await executeNonSend(activeClient, printFilename, originalFilename, msgNum);
                }
            } catch (error) {
                console.error("재연결 에러:", error);
            }
            console.log("웹소켓 연결에 실패하였습니다");
            return false;
        }
    };

    const executeNonSend = async (client, printFilename, originalFilename, msgNum) => {
        const nonChatMessage = {
            chatKey: printFilename,
            fileNm: originalFilename,
            msgNum: msgNum,
            role: '0',
            autoFl: false
        };
        await client.send("/app/nonUserChat/adminMessage", {}, JSON.stringify(nonChatMessage));
        await new Promise(resolve => setTimeout(resolve, 500));
        nonFetchChatMessages(msgNum, true);
        return true;
    };

    // 기한초과된 모든 비회원 채팅메세지 삭제
    const [nUserRemoveSt, setNUserRemoveSt] = useState(false);
    const nUserRemoveMsgTitle = "기한 초과된 모든 메세지를 삭제하시겠습니까?";
    const nUserRemoveMsgContent = "삭제 후 복구가 불가합니다";
    const nUserAllChatRemove = async () => {
        axios({
            method: 'post',
            url: '/member/nUserAllChatRemove',
        })
            .then(() => {
                // 비회원채팅 리렌더링
                selectNonMemberMsg();
                closeNUserRemoveSt();
                setNonChatShow(false);
            })
    };
    const closeNUserRemoveSt = () => {
        setNUserRemoveSt(false);
    }

    // 관리자 -> 사용자 읽음 전송
    const nonStompAdminRead = async (msgNum) => {
        if (stompClient) {
            const readChat = {
                msgNum: msgNum,
                readerRole: "ADMIN",
            };
            await stompClient.send("/app/nonUserChat/adminRead", {}, JSON.stringify(readChat));
        } else {
        }
    };

    const nonMessagesEndRef = useRef(null);


    /*
     * [스크롤 유지] 비회원채팅
     *  바닥 근처(80px 이내)를 보고 있을 때만 새 메세지를 따라 내려간다.
     *  위 내용을 읽는 중이면 그대로 둔다.
     */
    const nonMessagesEndRefStickRef = useRef(true);

    // 방을 바꾸면 비회원채팅은 다시 최신 메세지부터 보여준다
    useEffect(() => {
        nonMessagesEndRefStickRef.current = true;
    }, [sendMsgNum]);

    const handleNonMessagesEndRefScroll = () => {
        const el = nonMessagesEndRef.current;
        if (!el) return;
        nonMessagesEndRefStickRef.current = el.scrollHeight - el.scrollTop - el.clientHeight < 80;
    };

    /** @param force true 면 스크롤 위치와 무관하게 바닥으로 */
    const nonChatScrollBottom = (force) => {
        if (force) nonMessagesEndRefStickRef.current = true;
        // 위 내용을 읽는 중이면(바닥에서 떨어져 있으면) 끌어내리지 않는다
        if (!nonMessagesEndRefStickRef.current) return;
        if (nonMessagesEndRef.current) {
            nonMessagesEndRef.current.scrollTo({
                top: nonMessagesEndRef.current.scrollHeight,
                behavior: 'smooth',
            });
        }
    };

    useEffect(() => {
        if (nonMessagesEndRefStickRef.current) nonChatScrollBottom();
    }, [nonChatMessages]);

    const nonChatInputRef = React.useRef(null);
    const nonChatMaxTextAreaHeight = 132; // 최대 높이 (약 6줄 — CSS max-height 와 같은 값)
    const NON_CHAT_TEXTAREA_MIN = 42;     // 한 줄 높이

    /** 주문서 채팅과 동일 — 입력창 높이만 조정하고 목록높이는 flex 에 맡긴다 */
    const nonResizeTextArea = () => {
        const textArea = nonChatInputRef.current;
        if (!textArea) return;

        const wasAtBottom = nonMessagesEndRefStickRef.current;

        textArea.style.height = `${NON_CHAT_TEXTAREA_MIN}px`;
        const newHeight = Math.min(
            Math.max(textArea.scrollHeight, NON_CHAT_TEXTAREA_MIN),
            nonChatMaxTextAreaHeight,
        );
        textArea.style.height = `${newHeight}px`;

        if (wasAtBottom) nonChatScrollBottom(true);
    };

    const nonHandleChatInput = (e) => {
        setNonMessage(e.target.value);
    };

    /* 전송 후 빈 값이 되었을 때도 반드시 한 줄 높이로 돌아오도록 조건 없이 실행한다 */
    useEffect(() => {
        nonResizeTextArea();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nonMessage]);

    const saveNonChatFile = async () => {
        if (!nonSelectedFile) {
            return;
        }
        const formData = new FormData();
        formData.append('file', nonSelectedFile);
        const response = await axios.post('/member/upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        const fileKeys = await response.data;

        if (!fileKeys) {
            console.log("응답된 데이터가 존재하지 않습니다")
            return;
        }

        await nonSendMessage(fileKeys.printFilename, fileKeys.originalFilename, sendMsgNum);
        setNonShowChatFile(false);
    };

    const nonTriggerFileInput = () => {
        nonFileInputRef.current.click();
        setNonShowChatFile(true);
    };

    const nonShowChatFileClose = (() => {
        nonResetFileInput();
        setNonShowChatFile(false);
    })

    const nonResetFileInput = () => {
        nonFileInputRef.current.value = "";
        setNonSelectedFile(null);
        setNonSelectedFileUrl(null);
    };

    const nonHandleFileUpload = (event) => {
        if (event.target.files.length > 0) {
            const file = event.target.files[0];
            setNonSelectedFile(file);
            setNonSelectedFileUrl(URL.createObjectURL(file));
        }
    };

    const nonHandleEmojiClick = (emoji) => {
        const newMessage = nonMessage + emoji.native;
        setNonMessage(newMessage);
        setShowNonEmoji(false);
    };

    const [nonChatModifySt, setNonChatModifySt] = useState(false)
    const [nonChatFileModifySt, setNonChatFileModifySt] = useState(false)
    const [nonMessageToModify, setNonMessageToModify] = useState(null);

    const nonChatModifyFalseFn = (() => {
        setNonChatModifySt(false);
    })
    const nonChatFileModifyFalseFn = (() => {
        setNonChatFileModifySt(false);
    })

    const openNonModifyModal = (message) => {
        setNonMessageToModify(message);
        if (message.chatKey.startsWith("chatFile")) {
            setNonChatFileModifySt(true);
        } else {
            setNonChatModifySt(true);
        }
    };

    const updateNonChatMessage = (modifiedMessage) => {
        const index = nonChatMessages.findIndex(msg => msg.seqnum === modifiedMessage.seqnum);
        const updatedChatMessages = [...nonChatMessages];
        updatedChatMessages[index] = modifiedMessage;
        setNonChatMessages(updatedChatMessages);
    };

    const nonChatFileModify = (changeFile, changeData) => {

        if (changeData.chatKey.startsWith('chatFile')) {
            // Handle the case where changeFile is a file
            const formData = new FormData();
            formData.append('changeFile', changeFile);
            formData.append('seqnum', changeData.seqnum);
            axios({
                method: 'post',
                url: '/member/chatFileModify/',
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: LCAT
                },
            })
                .then(async (response) => {
                    const data = response.data;
                    const userInfo = {
                        keyNumber: data.msgNum,
                        sendFl: true
                    };
                    await updateNonChatMessage(response.data)
                    await stompClient.send("/app/nonUserChat/modifyMessage", {}, JSON.stringify(userInfo));
                    setNonChatFileModifySt(false);
                })
        } else {
            axios({
                method: 'post',
                url: '/member/chatFileModify/',
                params: {
                    seqnum: changeData.seqnum
                },

                data: changeFile,

                headers: {
                    'Content-Type': 'text/plain',
                    Authorization: LCAT
                },
            })
                .then(async (response) => {
                    const data = response.data;
                    const userInfo = {
                        keyNumber: data.msgNum,
                        sendFl: true
                    };
                    await updateNonChatMessage(response.data)
                    await stompClient.send("/app/nonUserChat/modifyMessage", {}, JSON.stringify(userInfo));
                    setNonChatModifySt(false);
                })
        }
    };

    const [nonChatDeleteSt, setNonChatDeleteSt] = useState(false);
    const nonChatDeleteFalseFn = (() => {
        setNonChatDeleteSt(false);
    })

    const openNonDeleteModal = ((chatData) => {
        if (chatData !== null) {
            setNonMessageToModify(chatData);
        }
        setNonChatDeleteSt(true);
    })

    const deleteNonChat = ((deleteChat) => {
        axios({
            method: 'post',
            url: '/member/deleteChat/',
            params: {
                seqnum: deleteChat.seqnum
            },
            headers: {
                Authorization: LCAT
            },
        })
            .then(async () => {
                const userInfo = {
                    keyNumber: deleteChat.msgNum,
                    sendFl: true
                };
                await setNonChatMessages((prevChatMessages) => prevChatMessages.filter(message => message.seqnum !== deleteChat.seqnum));
                await selectNonMemberMsg();
                await stompClient.send("/app/nonUserChat/deleteMessage", {}, JSON.stringify(userInfo));
                nonChatDeleteFalseFn();
            })
    })

    const [nonSelectedClickFile, setNonSelectedClickFile] = useState(null);
    const [nonSelectedClickSt, setNonSelectedClickSt] = useState(false);

    const nonClickFileDetail = ((file) => {
        setNonSelectedClickFile(file);
        setNonSelectedClickSt(true);
    })
    const nonClickFileClose = (() => {
        setNonSelectedClickSt(false);
    })

    const convertToNonMemberDate = ((regDate) => {
        const regTime = new Date(regDate);
        const currentTime = new Date();
        const timeDifference = currentTime - regTime;

        // 날짜 차이를 분으로 변환
        const minutesDiff = Math.floor(timeDifference / 60000);
        const hoursDiff = Math.floor(minutesDiff / 60);
        const daysDiff = Math.floor(hoursDiff / 24);

        // 날짜 차이가 1일 미만일 때
        if (daysDiff < 1) {
            if (minutesDiff < 1) return "방금";
            if (minutesDiff < 60) return `${minutesDiff}분 전`;
            return `${hoursDiff}시간 전`;
        } else if (daysDiff === 1) {
            return "어제";
        } else if (daysDiff === 2) {
            return "2일 전";
        } else if (daysDiff < 7) {
            return `${daysDiff}일 전`;
        } else {
            // 7일 이상 차이날 때는 월-일 형식으로 반환
            return `${(regTime.getMonth() + 1).toString().padStart(2, '0')}-${regTime.getDate().toString().padStart(2, '0')}`;
        }
    })

    // 자동응답시작
    useEffect(() => {
        if (autoRes) {
            selectAutoResList();
        }
    }, [autoRes])


    const selectAutoResList = () => axios({
        method: 'get',
        url: '/member/selectAutoResList/',
        headers: {
            Authorization: LCAT
        },
    })
        .then((response) => {
        })


    // 매크로시작

    useEffect(() => {
        if (macro) {
            selectMacroList();
        }
    }, [macro])

    const [macroMstList, setMacroMstList] = useState([]);
    const [macroDtList, setMacroDtList] = useState([]);

    const selectMacroList = () => axios({
        method: 'get',
        url: '/member/selectMacroList/',
        headers: {
            Authorization: LCAT
        },
    })
        .then((response) => {
            setMacroMstList(response.data)
        })


    const [isMacroPopupVisible, setIsMacroPopupVisible] = useState(false);
    const toggleMacroPopup = () => {
        setIsMacroPopupVisible(true);
    };

    return (
        <div id='m-a-order-chat-pg-container'>
            {chatStarted ?
                <div className="font-t-cont">
                    <div className="m-a-chatMsg-container">
                        <div className="m-a-chat-blank-space"></div>
                        <div className="m-a-chat-header-container">
                            <div className="m-a-chat-header-frame">
                                <img className="m-a-chat-header-img" src={mainChatPeople} alt="consultant"/>
                                <div className="m-a-chat-header-text font-t-title font-s-16">주문서채팅</div>
                            </div>
                            <img onClick={() => setChatStarted(false)} className="m-a-chat-header-close-img" src={commonClose} alt="close"/>
                        </div>
                        <div className="m-a-chat-body-container" ref={messagesEndRef} onScroll={handleMessagesEndRefScroll}>
                            {chatMessages && chatMessages.map((message, index) => (
                                <div key={index}>
                                    {!isSending && (isFirstMessageOfDay(message, chatMessages[index - 1]) &&
                                        <div className="m-a-chat-first-time-frame">
                                            <div className="m-a-chat-first-time font-t-cont">{formatDate(new Date(message.regTime))}</div>
                                        </div>
                                    )}
                                    {message.memberDTO && message.memberDTO.role === '0' ?
                                        <div className="m-a-chat-userProfile-frame1" style={{
                                            display: "flex",
                                            justifyContent: message.memberDTO && message.memberDTO.role === '0' ? 'flex-start' : 'flex-end'
                                        }}>
                                            <div className="m-a-chat-userProfile-frame2">
                                                <div className="m-a-chat-userProfile-frame">
                                                    {message.memberDTO.profileDTO ?
                                                        <img className="display-block wd-100pc ht-100pc"
                                                             style={{borderRadius: "50%", objectFit: "cover"}}
                                                             alt="profile-img"
                                                             src={
                                                                 "https://toeloperfile.s3.ap-northeast-2.amazonaws.com/profileImage/" + message.memberDTO.profileDTO.filename
                                                             }/>
                                                        :
                                                        <img className="display-block wd-100pc ht-100pc"
                                                             style={{borderRadius: "50%", objectFit: "cover"}}
                                                             src={profileDefaultImg} alt="profile-img"/>
                                                    }
                                                </div>
                                                <div className="m-a-chat-nameCont-frame">
                                                    <div className="text-left font-s-15 font-t-title">{message.mstUserNm}</div>
                                                    <div className="m-a-chat-content-time-frame">
                                                        {message.chatKey.startsWith("chatFile") ?
                                                            <div onClick={!message.removeFl ? () => clickFileDetail(message) : null}
                                                                className="m-a-chatKey-file-container">
                                                                {/*사용자이미지*/}
                                                                {isImage(message.chatKey) ?
                                                                    <div className="m-a-chatKey-img-frame">
                                                                        {!message.removeFl ?
                                                                            <img className="m-a-chatKey-short-img" alt="chatImg" src={message.fileUrl}/>
                                                                            :
                                                                            <div className="m-a-chatKey-file-expiration-img-container">
                                                                                <img className="m-a-chatKey-file-expiration-img" alt="expiration" src={trash}/>
                                                                                <div className="m-a-chatKey-file-expiration-text">(기한만료)</div>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                    :
                                                                    // 사용자동영상
                                                                    isVideo(message.chatKey) ?
                                                                        <div className="m-a-chatKey-video-frame"
                                                                             style={{pointerEvents: "none"}}>
                                                                            {!message.removeFl ?
                                                                                <video width="250" height="250"
                                                                                       controls>
                                                                                    <source src={message.fileUrl}
                                                                                            type="video/mp4"
                                                                                            style={{pointerEvents: "auto"}}/>
                                                                                </video>
                                                                                :
                                                                                <div
                                                                                    className="m-a-chatKey-file-expiration-img-container">
                                                                                    <img
                                                                                        className="m-a-chatKey-file-expiration-img"
                                                                                        alt="expiration" src={trash}/>
                                                                                    <div
                                                                                        className="m-a-chatKey-file-expiration-text">(기한만료)
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                        :
                                                                        // 사용자파일
                                                                        <div className="m-a-chatKey-file-frame1">
                                                                            {!message.removeFl ?
                                                                                <div
                                                                                    className="m-a-chatKey-file-frame2">
                                                                                    <div
                                                                                        className="m-a-chatKey-file-img-frame user-center">
                                                                                        <img
                                                                                            className="m-a-chatKey-file-img"
                                                                                            alt="fileImg"
                                                                                            src={chatFileImg}/>
                                                                                    </div>
                                                                                    <div
                                                                                        className="m-a-chatKey-fileNm-text-frame">
                                                                                        <span
                                                                                            className="m-a-chatKey-fileNm-text font-t-title">{message.fileNm}</span>
                                                                                    </div>
                                                                                    <div
                                                                                        className="m-a-chatKey-expiration-date font-t-cont"> ~ {oneMonthFromNow(message.deadline)}까지
                                                                                    </div>
                                                                                </div>
                                                                                :
                                                                                <div
                                                                                    className="m-a-chatKey-file-expiration-img-container">
                                                                                    <img
                                                                                        className="m-a-chatKey-file-expiration-img"
                                                                                        alt="expiration" src={trash}/>
                                                                                    <div
                                                                                        className="m-a-chatKey-file-expiration-text">(기한만료)
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                }
                                                            </div>
                                                            :
                                                            // 사용자텍스트
                                                            <div className="m-a-chat-msg-content-frame">
                                                                <Linkify
                                                                    componentDecorator={(decoratedHref, decoratedText, key) => (
                                                                        <a style={{color: "orangered"}} target="blank"
                                                                           href={decoratedHref} key={key}>
                                                                            {decoratedText}
                                                                        </a>
                                                                    )}
                                                                >
                                                                    <div
                                                                        className="m-a-chat-msg-content font-t-cont font-s-14">{DOMPurify.sanitize(message.chatKey)}
                                                                    </div>
                                                                </Linkify>
                                                            </div>
                                                        }
                                                        <div className="m-a-chat-msg-time-frame">
                                                            {!message.removeFl ?
                                                                <div
                                                                    className="m-a-chat-msg-time font-t-cont font-s-11">{formatTime(message.regTime)}
                                                                </div>
                                                                :
                                                                null
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        // 주문서 관리자채팅
                                        <div className="m-a-chat-adminProfile-frame1">
                                            <div className="m-a-chat-adminProfile-frame2"
                                                 style={{display: "flex", justifyContent: 'flex-end'}}>
                                                {!message.removeFl ?
                                                    <div className="m-a-chat-edit-remove-time-frame wd-30pc">
                                                        {/* 🚨 [개선] 관리자가 메시지 발송 중 지연 시간 동안 왼쪽에 도트 애니메이션 출력 */}
                                                        {message.isPending ? (
                                                            <div style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                marginRight: '8px',
                                                                color: '#FF6324',
                                                                fontSize: '11px',
                                                                fontWeight: 'bold'
                                                            }}>
                                                                <span className="spinner-border spinner-border-sm"
                                                                      style={{
                                                                          width: '11px',
                                                                          height: '11px',
                                                                          marginRight: '4px'
                                                                      }}></span>
                                                                <span>••• 전송중</span>
                                                            </div>
                                                        ) : (
                                                            <div className="m-a-chat-edit-remove-frame gap7">
                                                                {message && message.unreadCount > 0 ? <div
                                                                    className="m-a-chat-admin-unreadCount-frame user-center font-s-13">
                                                                    <div className="m-a-chat-admin-unreadCount">1</div>
                                                                </div> : null}
                                                                <div onClick={() => openModifyModal(message)}
                                                                     className="m-a-chat-edit font-s-12">수정
                                                                </div>
                                                                <div onClick={() => openDeleteModal(message)}
                                                                     className="m-a-chat-remove font-s-12">삭제
                                                                </div>
                                                            </div>
                                                        )}
                                                        {!message.isPending && <div
                                                            className="m-a-chat-msg-time font-t-cont font-s-11 m-l-15">{formatTime(message.regTime)}</div>}
                                                    </div>
                                                    :
                                                    null
                                                }
                                                <div style={{opacity: message.isPending ? 0.6 : 1}}>
                                                    {message.chatKey.startsWith("chatFile") ?
                                                        <div
                                                            onClick={!message.removeFl && !message.isPending ? () => clickFileDetail(message) : null}
                                                            className="m-a-chatKey-file-container m-l-5">
                                                            {isImage(message.chatKey) ?
                                                                <div className="m-a-chatKey-img-frame"><img
                                                                    className="m-a-chatKey-long-img" alt="chatImg"
                                                                    src={message.fileUrl || selectedFileUrl}/></div>
                                                                :
                                                                isVideo(message.chatKey) ?
                                                                    <div className="m-a-chatKey-video-frame"
                                                                         style={{pointerEvents: "none"}}>
                                                                        {!message.removeFl ?
                                                                            <video width="220" height="220" controls>
                                                                                <source src={message.fileUrl}
                                                                                        type="video/mp4"
                                                                                        style={{pointerEvents: "auto"}}/>
                                                                            </video>
                                                                            : <div
                                                                                className="m-a-chatKey-file-expiration-img-container"
                                                                                style={{textAlign: "center"}}><img
                                                                                className="m-a-chatKey-file-expiration-img"
                                                                                alt="expiration" src={trash}/>
                                                                                <div
                                                                                    className="m-a-chatKey-file-expiration-text">(기한만료)
                                                                                </div>
                                                                            </div>}
                                                                    </div>
                                                                    :
                                                                    <div className="m-a-chatKey-file-frame1">
                                                                        {!message.removeFl ?
                                                                            <div className="m-a-chatKey-file-frame2">
                                                                                <div
                                                                                    className="m-a-chatKey-file-img-frame user-center">
                                                                                    <img
                                                                                        className="m-a-chatKey-file-img"
                                                                                        alt="fileImg"
                                                                                        src={chatFileImg}/></div>
                                                                                <div
                                                                                    className="m-a-chatKey-fileNm-text-frame">
                                                                                    <span
                                                                                        className="m-a-chatKey-fileNm-text font-t-title">{message.fileNm}</span>
                                                                                </div>
                                                                                <div
                                                                                    className="m-a-chatKey-expiration-date font-t-cont"> ~ {oneMonthFromNow(message.deadline)}까지
                                                                                </div>
                                                                            </div>
                                                                            : <div
                                                                                className="m-a-chatKey-file-expiration-img-container"
                                                                                style={{textAlign: "center"}}><img
                                                                                className="m-a-chatKey-file-expiration-img"
                                                                                alt="expiration" src={trash}/>
                                                                                <div
                                                                                    className="m-a-chatKey-file-expiration-text">(기한만료)
                                                                                </div>
                                                                            </div>}
                                                                    </div>
                                                            }
                                                        </div>
                                                        :
                                                        <div className="m-a-chat-msg-admin-content-frame"
                                                             style={{backgroundColor: message.isPending ? '#FFB27A' : ''}}>
                                                            <Linkify
                                                                componentDecorator={(decoratedHref, decoratedText, key) => (
                                                                    <a style={{color:"orangered"}} target="blank"
                                                                       href={decoratedHref}
                                                                       key={key}>{decoratedText}</a>)}>
                                                                <div
                                                                    className="m-a-chat-msg-admin-content font-t-cont font-s-14">{DOMPurify.sanitize(message.chatKey)}</div>
                                                            </Linkify>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            ))}
                        </div>
                        <div className="m-a-chat-msgInput-container">
                            {/*주문서 채팅인풋 프레임*/}
                            <div className="m-a-chat-send-frame">
                                {/*emoji & upload & remove*/}
                                <div className="m-a-chat-emoji-photo-frame m-l-10">
                                    <div onClick={() => !isSending && setShowEmoji(!showEmoji)}
                                         className="m-a-chat-show-emoji">
                                        <img alt='' className="m-a-chat-show-emoji-icon" src={mainChatEmoji}/>
                                    </div>
                                    {/*이모티콘*/}
                                    {showEmoji ?
                                        <div className="m-a-chat-show-emoji-popup-frame1">
                                            <div className="m-a-chat-show-emoji-popup-frame2">
                                                <Picker
                                                    onEmojiSelect={handleEmojiClick}
                                                    previewPosition="none"
                                                    searchPosition="none"
                                                    skinTonePosition="none"
                                                    locale="kr"
                                                />
                                            </div>
                                        </div>
                                        :
                                        null
                                    }
                                    {/*파일업로드*/}
                                    <div className="m-a-chat-fileUpload-frame">
                                        <input
                                            type="file"
                                            ref={fileInputRef}
                                            style={{display: "none"}}
                                            onChange={handleFileUpload}
                                        />
                                        <button className="m-a-chat-fileUpload-button"
                                                onClick={triggerFileInput}>
                                            <img alt='fileUploadImg' className="wd-25 ht-25"
                                                 src={mainChatUpload}/>
                                        </button>
                                    </div>
                                    {/*주문서 관리자매크로*/}
                                    <div className="m-a-chat-fileUpload-frame" style={{marginLeft: "-3px"}}>
                                        <button onClick={toggleMacroPopup} className="m-a-chat-fileUpload-button"
                                        >
                                            <img alt='' className="wd-25 ht-25 m-a-opc-06"
                                                 src={commonMacro}/>
                                        </button>
                                    </div>
                                </div>
                                {/*채팅 textarea 프레임*/}
                                <div className="m-a-chat-textarea-frame">
                                    {/*채팅 textarea*/}
                                    <textarea ref={chatInputRef} placeholder=""
                                              spellCheck="false" value={message}
                                              className="m-a-textarea font-s-14 m-a-chat-textarea wd-100pc"
                                              onChange={handleChatInput}/>
                                </div>
                                <div onClick={handleSendProcess} className="m-a-chat-send-bt-frame"
                                     style={{pointerEvents: isSending || message.trim() === '' ? 'none' : 'auto'}}>
                                    <img alt='' className="m-a-chat-send-bt-img"
                                         style={{opacity: message.length > 0 && !isSending ? "1" : "0.4"}}
                                         src={mainChatSend}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                :
                // 비회원채팅 오픈
                nonChatShow ?
                    <div className="">
                        <div className="m-a-chatMsg-container">
                            <div className="m-a-chat-blank-space"></div>
                            {/*비회원 채팅헤더*/}
                            <div className="m-a-chat-header-container">
                                <div className="m-a-chat-header-frame">
                                    <img className="m-a-chat-header-img" src={mainChatPeople} alt="consultant"/>
                                    <div className="m-a-chat-header-text font-t-title font-s-16">비회원채팅</div>
                                </div>
                                <img onClick={() => setNonChatShow(false)} className="m-a-chat-header-close-img"
                                     src={commonClose} alt="close"/>
                            </div>
                            <div className="m-a-chat-body-container" ref={nonMessagesEndRef} onScroll={handleNonMessagesEndRefScroll}>
                                {/*비회원 채팅바디*/}
                                {nonChatMessages.map((message, index) => (
                                    <div key={index}>
                                        {(isFirstMessageOfDay(message, nonChatMessages[index - 1]) &&
                                            <div className="m-a-chat-first-time-frame">
                                                <div
                                                    className="m-a-chat-first-time font-t-cont">{formatDate(new Date(message.regTime))}</div>
                                            </div>
                                        )}
                                        {message && message.role === '1' ?
                                            // 비회원 사용자프로필
                                            <div className="m-a-chat-userProfile-frame1" style={{
                                                display: "flex",
                                                justifyContent: message && message.role === '1' ? "flex-start" : "flex-end"
                                            }}>
                                                <div className="m-a-chat-userProfile-frame2">
                                                    <div className="m-a-chat-userProfile wd-50 ht-50">
                                                        <img className="wd-100pc ht-100pc" style={{objectFit: "cover"}} src={profileDefaultImg} alt="profile-img"/>
                                                    </div>
                                                    <div className="m-a-chat-nameCont-frame">
                                                        <div
                                                            className="m-a-chat-userNm font-s-15 font-t-title">{message.mstUserNm}</div>
                                                        <div className="m-a-chat-content-time-frame">
                                                            {/*비회원 챗메시지 프레임*/}
                                                            {message.chatKey.startsWith("chatFile") ?
                                                                <div
                                                                    onClick={!message.removeFl ? () => nonClickFileDetail(message) : null}
                                                                    className="m-a-chatKey-file-container">
                                                                    {/*비회원 사용자이미지*/}
                                                                    {isImage(message.chatKey) ?
                                                                        <div className="m-a-chatKey-img-frame">
                                                                            {!message.removeFl ?
                                                                                <img className="m-a-chatKey-short-img"
                                                                                     alt="chatImg"
                                                                                     src={message.fileUrl}/>
                                                                                :
                                                                                <div
                                                                                    className="m-a-chatKey-file-expiration-img-container">
                                                                                    <img
                                                                                        className="m-a-chatKey-file-expiration-img"
                                                                                        alt="expiration" src={trash}/>
                                                                                    <div
                                                                                        className="m-a-chatKey-file-expiration-text">(기한만료)
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                        :
                                                                        // 비회원 사용자동영상
                                                                        isVideo(message.chatKey) ?
                                                                            <div className="m-a-chatKey-video-frame"
                                                                                 style={{pointerEvents: "none"}}>
                                                                                {!message.removeFl ?
                                                                                    <video width="250" height="250"
                                                                                           controls>
                                                                                        <source src={message.fileUrl}
                                                                                                type="video/mp4"
                                                                                                style={{pointerEvents: "auto"}}/>
                                                                                    </video>
                                                                                    :
                                                                                    <div
                                                                                        className="m-a-chatKey-file-expiration-img-container">
                                                                                        <img
                                                                                            className="m-a-chatKey-file-expiration-img"
                                                                                            alt="expiration"
                                                                                            src={trash}/>
                                                                                        <div
                                                                                            className="m-a-chatKey-file-expiration-text">(기한만료)
                                                                                        </div>
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                            :
                                                                            // 비회원 사용자파일
                                                                            <div className="m-a-chatKey-file-frame1">
                                                                                {!message.removeFl ?
                                                                                    <div
                                                                                        className="m-a-chatKey-file-frame2">
                                                                                        <div
                                                                                            className="m-a-chatKey-file-img-frame user-center">
                                                                                            <img
                                                                                                className="m-a-chatKey-file-img"
                                                                                                alt="fileImg"
                                                                                                src={chatFileImg}/>
                                                                                        </div>
                                                                                        <div
                                                                                            className="m-a-chatKey-fileNm-text-frame">
                                                                                            <span
                                                                                                className="m-a-chatKey-fileNm-text font-t-title">{message.fileNm}</span>
                                                                                        </div>
                                                                                        <div
                                                                                            className="m-a-chatKey-expiration-date font-t-cont"> ~ {oneMonthFromNow(message.deadline)}까지
                                                                                        </div>
                                                                                    </div>
                                                                                    :
                                                                                    <div
                                                                                        className="m-a-chatKey-file-expiration-img-container">
                                                                                        <img
                                                                                            className="m-a-chatKey-file-expiration-img"
                                                                                            alt="expiration"
                                                                                            src={trash}/>
                                                                                        <div
                                                                                            className="m-a-chatKey-file-expiration-text">(기한만료)
                                                                                        </div>
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                    }
                                                                </div>
                                                                :
                                                                // 비회원 사용자텍스트
                                                                <div className="m-a-chat-msg-content-frame">
                                                                    <Linkify
                                                                        componentDecorator={(decoratedHref, decoratedText, key) => (
                                                                            <a style={{color: "orangered"}}
                                                                               target="blank"
                                                                               href={decoratedHref} key={key}>
                                                                                {decoratedText}
                                                                            </a>
                                                                        )}
                                                                    >
                                                                        <div
                                                                            className="m-a-chat-msg-content font-t-cont font-s-14">{DOMPurify.sanitize(message.chatKey)}
                                                                        </div>
                                                                    </Linkify>
                                                                </div>
                                                            }
                                                            <div className="m-a-chat-msg-time-frame">
                                                                {!message.removeFl ?
                                                                    <div
                                                                        className="m-a-chat-msg-time font-t-cont font-s-11">{formatTime(message.regTime)}
                                                                    </div>
                                                                    :
                                                                    null
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            // 비회원 관리자채팅
                                            <div className="m-a-chat-adminProfile-frame1">
                                                <div className="m-a-chat-adminProfile-frame2"
                                                     style={{
                                                         display: "flex",
                                                         justifyContent: message.memberDTO && message.memberDTO.role === '0' ? 'flex-start' : 'flex-end'
                                                     }}>
                                                    {!message.removeFl && !message.autoFl ?
                                                        <div className="m-a-chat-edit-remove-time-frame">
                                                            <div
                                                                className="m-a-chat-edit-remove-frame">
                                                                {message && message.unreadCount > 0 ?
                                                                    <div
                                                                        className="m-a-chat-admin-unreadCount-frame user-center font-s-13">
                                                                        <div
                                                                            className="m-a-chat-admin-unreadCount">1
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    null
                                                                }
                                                                <div
                                                                    onClick={() => openNonModifyModal(message)}
                                                                    className="m-a-chat-edit font-t-cont font-s-13 m-l-5">수정
                                                                </div>
                                                                <div
                                                                    onClick={() => openNonDeleteModal(message)}
                                                                    className="m-a-chat-remove font-t-cont font-s-13 m-l-5">삭제
                                                                </div>
                                                            </div>
                                                            {!message.removeFl ?
                                                                <div
                                                                    className="m-a-chat-msg-time font-t-cont font-s-11 m-l-10">{formatTime(message.regTime)}
                                                                </div>
                                                                :
                                                                null
                                                            }
                                                        </div>
                                                        :
                                                        null
                                                    }
                                                    {/*비회원 관리자 챗메시지 프레임*/}
                                                    <div>
                                                        {message.chatKey.startsWith("chatFile") ?
                                                            <div
                                                                onClick={!message.removeFl ? () => nonClickFileDetail(message) : null}
                                                                className="m-a-chatKey-file-container m-l-5">
                                                                {/*관리자이미지*/}
                                                                {isImage(message.chatKey) ?
                                                                    <div className="m-a-chatKey-img-frame">
                                                                        {!message.removeFl ?
                                                                            <img className="m-a-chatKey-long-img"
                                                                                 alt="chatImg" src={message.fileUrl}/>
                                                                            :
                                                                            <div
                                                                                className="m-a-chatKey-file-expiration-img-container"
                                                                                style={{textAlign: "center"}}>
                                                                                <img
                                                                                    className="m-a-chatKey-file-expiration-img"
                                                                                    alt="expiration" src={trash}/>
                                                                                <div
                                                                                    className="m-a-chatKey-file-expiration-text">(기한만료)
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                    :
                                                                    // 비회원 관리자동영상
                                                                    isVideo(message.chatKey) ?
                                                                        <div className="m-a-chatKey-video-frame">
                                                                            {!message.removeFl ?
                                                                                <video width="220" height="220"
                                                                                       controls>
                                                                                    <source src={message.fileUrl}
                                                                                            type="video/mp4"/>
                                                                                </video>
                                                                                :
                                                                                <div
                                                                                    className="m-a-chatKey-file-expiration-img-container">
                                                                                    <img
                                                                                        className="m-a-chatKey-file-expiration-img"
                                                                                        alt="expiration" src={trash}/>
                                                                                    <div
                                                                                        className="m-a-chatKey-file-expiration-text">(기한만료)
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                        :
                                                                        // 비회원 관리자파일
                                                                        <div className="m-a-chatKey-file-frame1">
                                                                            {!message.removeFl ?
                                                                                <div
                                                                                    className="m-a-chatKey-file-frame2">
                                                                                    <div
                                                                                        className="m-a-chatKey-file-img-frame user-center">
                                                                                        <img
                                                                                            className="m-a-chatKey-file-img"
                                                                                            alt="fileImg"
                                                                                            src={chatFileImg}/>
                                                                                    </div>
                                                                                    <div
                                                                                        className="m-a-chatKey-fileNm-text-frame">
                                                                                        <span
                                                                                            className="m-a-chatKey-fileNm-text font-t-title">{message.fileNm}</span>
                                                                                    </div>
                                                                                    <div
                                                                                        className="m-a-chatKey-expiration-date font-t-cont"> ~ {oneMonthFromNow(message.deadline)}까지
                                                                                    </div>
                                                                                </div>
                                                                                :
                                                                                <div
                                                                                    className="m-a-chatKey-file-expiration-img-container">
                                                                                    <img
                                                                                        className="m-a-chatKey-file-expiration-img"
                                                                                        alt="expiration" src={trash}/>
                                                                                    <div
                                                                                        className="m-a-chatKey-file-expiration-text">(기한만료)
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                }
                                                            </div>
                                                            :
                                                            // 비회원 관리자텍스트
                                                            <div className="m-a-chat-msg-admin-content-frame">
                                                                <Linkify
                                                                    componentDecorator={(decoratedHref, decoratedText, key) => (
                                                                        <a style={{color: "orangered"}} target="blank"
                                                                           href={decoratedHref} key={key}>
                                                                            {decoratedText}
                                                                        </a>
                                                                    )}
                                                                >
                                                                    <div
                                                                        className="m-a-chat-msg-admin-content font-t-cont font-s-14">{DOMPurify.sanitize(message.chatKey)}</div>
                                                                </Linkify>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                ))}
                            </div>
                            <div className="m-a-chat-msgInput-container">
                                {/*비회원 채팅인풋 프레임*/}
                                <div className="m-a-chat-send-frame">
                                    {/*emoji & upload & remove*/}
                                    <div className="m-a-chat-emoji-photo-frame m-l-10">
                                        <div onClick={() => setShowNonEmoji(!showNonEmoji)}
                                             className="m-a-chat-show-emoji">
                                            <img alt='' className="m-a-chat-show-emoji-icon"
                                                 src={mainChatEmoji}/>
                                        </div>
                                        {/*비회원 이모티콘*/}
                                        {showNonEmoji ?
                                            <div className="m-a-chat-show-emoji-popup-frame1">
                                                <div className="m-a-chat-show-emoji-popup-frame2">
                                                    <Picker
                                                        onEmojiSelect={nonHandleEmojiClick}
                                                        previewPosition="none"
                                                        searchPosition="none"
                                                        skinTonePosition="none"
                                                        locale="kr"
                                                    />
                                                </div>
                                            </div>
                                            :
                                            null
                                        }
                                        {/*비회원 파일업로드*/}
                                        <div className="m-a-chat-fileUpload-frame">
                                            <input
                                                type="file"
                                                ref={nonFileInputRef}
                                                style={{display: "none"}}
                                                onChange={nonHandleFileUpload}
                                            />
                                            <button className="m-a-chat-fileUpload-button"
                                                    onClick={nonTriggerFileInput}>
                                                <img alt='fileUploadImg' className="wd-25 ht-25"
                                                     src={mainChatUpload}/>
                                            </button>
                                        </div>
                                        {/*비회원 관리자매크로*/}
                                        <div className="m-a-chat-fileUpload-frame" style={{marginLeft: "-3px"}}>
                                            <button onClick={toggleMacroPopup} className="m-a-chat-fileUpload-button">
                                                <img alt='' className="wd-25 ht-25 m-a-opc-06"
                                                     src={commonMacro}/>
                                            </button>
                                        </div>
                                    </div>
                                    {/*비회원채팅 textarea 프레임*/}
                                    <div className="m-a-chat-textarea-frame">
                                        {/*비회원채팅 textarea*/}
                                        <textarea ref={nonChatInputRef} placeholder=""
                                                  spellCheck="false" value={nonMessage}
                                                  className="m-a-textarea font-s-14 m-a-chat-textarea wd-100pc"
                                                  onChange={nonHandleChatInput}
                                                  // onKeyDown={(e) => {
                                                  //     if (e.key === 'Enter' && !e.shiftKey) {
                                                  //         e.preventDefault();
                                                  //         nonSendMessage(nonMessage, null, sendMsgNum);
                                                  //         setNonMessage('');
                                                  //         nonChatInputRef.current.style.height = '42px';
                                                  //     }
                                                  // }}
                                        />
                                    </div>
                                    <div onClick={() => {
                                        nonSendMessage(nonMessage, null, sendMsgNum);
                                        nonChatScrollBottom(true); // 내가 보낸 직후에는 최신으로
                                        setNonMessage('');
                                        nonChatInputRef.current.style.height = '42px';
                                    }} className="m-a-chat-send-bt-frame">
                                        <img alt='' className="m-a-chat-send-bt-img"
                                             style={{opacity: message.length > 0 ? "1" : "0.6"}}
                                             src={mainChatSend}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div className="ht-100pc">
                        {/*주문서채팅탭*/}
                        {ordChat ?
                            <div className="m-a-body-container">
                                {renderChatTabs()}

                                <div className="m-a-chat-ymd-frame" style={{marginTop: "10px"}}>
                                    <MAdminYmdEvent startDate={startDate} endDate={endDate} startHandle={startHandle}
                                                   endHandle={endHandle}/>
                                </div>

                                {renderChatSearch(searchInput, handleSearchInputChange)}

                                {/*주문서채팅 프로필 컨테이너*/}
                                {filteredMemberList && filteredMemberList.map((member, i) => (
                                    <div key={i} onClick={() => handleUserNameClick(member, i)}>
                                        <div className="m-a-card m-t-15">
                                            <div className="m-a-chat-container">
                                                <div className="m-a-profile-frame">
                                                    {member.memberDTO.profileDTO ?
                                                        <img className="m-a-profile-frame-img"
                                                             src={"https://toeloperfile.s3.ap-northeast-2.amazonaws.com/profileImage/" + member.memberDTO.profileDTO.filename}
                                                             alt="profile"/>
                                                        :
                                                        <img className="m-a-profile-frame-img"
                                                             src={profileDefaultImg}
                                                             alt="profile"/>
                                                    }
                                                </div>
                                                <div className="m-a-chat-content-frame">
                                                    <div className="m-a-chat-content">
                                                        <div
                                                            className="m-a-chat-userNm font-t-title">{member && member.mstUserNm}</div>
                                                        {member && member.unreadCount > 0 ?
                                                            <div
                                                                className="m-a-chat-unreadCount">{member.unreadCount}</div>
                                                            : null}
                                                    </div>
                                                    <div className="m-a-chat-content">
                                                        {(member && member.chatKey.endsWith("png") ||
                                                            member.chatKey.endsWith("PNG") ||
                                                            member && member.chatKey.endsWith("jpg") ||
                                                            member.chatKey.endsWith("JPG")) ||
                                                        member.chatKey.endsWith("jpeg") ||
                                                        member.chatKey.endsWith("JPEG") ?
                                                            <div
                                                                className="m-a-chat-chatKey font-t-cont">[사진]</div>
                                                            : member.chatKey.startsWith("chatFile") ?
                                                                <div
                                                                    className="m-a-chat-chatKey font-t-cont">[파일]</div>
                                                                : <div className="m-a-chat-chatKey-text-frame">
                                        <span
                                            className="m-a-chat-chatKey-text font-t-cont">{member.chatKey}</span>
                                                                </div>
                                                        }
                                                        <div
                                                            className="m-a-chat-commingTime font-t-cont">{convertToNonMemberDate(member && member.regTime)}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/*주문서채팅 리스트 컨테이너*/}
                                        {focusedIndex === i && (
                                            <div
                                                className="m-a-card m-t-5 m-a-chat-ordList-container">
                                                {selectedUserOrderNumbers.filter(chatDt => chatDt.mstMbNum === member.mstMbNum).map((chatDt, i) => (
                                                    <div key={i}
                                                         className="m-a-chat-ordList-frame"
                                                         onClick={() => handleOrderNumberlick(chatDt, i)}>
                                                        <div
                                                            className="m-a-profile-ordList-frame">
                                                            <img
                                                                className="m-a-profile-ordList-frame-img"
                                                                src={ordChatListImg}
                                                                alt="profile"/>
                                                        </div>
                                                        <div
                                                            className="m-a-chat-ordList-content-frame">
                                                            <div
                                                                className="m-a-chat-ordList-content">
                                                                <div
                                                                    className="m-a-chat-ordNum font-t-title">{chatDt.chatOrdNum}</div>
                                                                {chatDt.unreadCount > 0 && chatDt.memberDTO.role === '0' ?
                                                                    <div
                                                                        className="m-a-chat-ordList-unreadCount">{chatDt.unreadCount}</div>
                                                                    :
                                                                    null
                                                                }
                                                            </div>
                                                            <div
                                                                className="m-a-chat-ordList-content">
                                                                {(chatDt && chatDt.chatKey.endsWith("png") ||
                                                                    chatDt.chatKey.endsWith("PNG") ||
                                                                    chatDt && chatDt.chatKey.endsWith("jpg") ||
                                                                    chatDt.chatKey.endsWith("JPG")) ||
                                                                chatDt.chatKey.endsWith("jpeg") ||
                                                                chatDt.chatKey.endsWith("JPEG") ?
                                                                    <div
                                                                        className="m-a-chat-ordList-chatKey font-t-cont">[사진]</div>
                                                                    : chatDt.chatKey.startsWith("chatFile") ?
                                                                        <div
                                                                            className="m-a-chat-ordList-chatKey font-t-cont">[파일]</div>
                                                                        :
                                                                        <div className="m-a-chat-chatKey-text-frame">
                                                                            <span className="m-a-chat-chatKey-text font-t-cont">{chatDt.chatKey}</span>
                                                                        </div>
                                                                }
                                                                <div
                                                                    className="m-a-chat-ordList-commingTime font-t-cont">{convertToNonMemberDate(chatDt && chatDt.regTime)}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                            :
                            // 비회원채팅탭
                            nonMember ?
                                <div className={(chatStarted || nonChatShow ? '챗목록' : 'm-a-body-container')}>
                                    {renderChatTabs()}
                                    {renderChatSearch(nonSearchInput, nonHandleSearchInputChange)}
                                    {/*비회원채팅 프로필 컨테이너*/}
                                    <div>
                                        {filteredNonMemberList && filteredNonMemberList.map((list, index) => (
                                            <div key={index} className="m-a-card m-t-15"
                                                 onClick={() => handleNonChatMessages(list && list, index)}>
                                                <div className="m-a-chat-container">
                                                    <div className="m-a-profile-frame">
                                                        <img className="m-a-profile-frame-img"
                                                             src={profileDefaultImg}
                                                             alt="profile"/>
                                                    </div>
                                                    <div className="m-a-chat-content-frame">
                                                        <div className="m-a-chat-content">
                                                            <div
                                                                className="m-a-chat-userNm font-t-title"
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center"
                                                                }}>Non
                                                                User
                                                            </div>
                                                            {nonMemberList[index].unreadCount > 0 && nonMemberList[index].role === '1' ?
                                                                <div
                                                                    className="m-a-chat-unreadCount">{nonMemberList[index].unreadCount}</div>
                                                                :
                                                                null
                                                            }
                                                        </div>
                                                        <div className="m-a-chat-content">
                                                            {(list && list.chatKey.endsWith("png") ||
                                                                list.chatKey.endsWith("PNG") ||
                                                                list.chatKey.endsWith("jpg") ||
                                                                list.chatKey.endsWith("JPG") ||
                                                                list.chatKey.endsWith("jpeg") ||
                                                                list.chatKey.endsWith("JPEG")) ?
                                                                <div
                                                                    className="m-a-chat-chatKey font-t-cont">[사진]</div>
                                                                : list.chatKey.startsWith("chatFile") ?
                                                                    <div
                                                                        className="m-a-chat-chatKey font-t-cont">[파일]</div>
                                                                    :
                                                                    <div className="m-a-chat-chatKey-text-frame">
                                        <span
                                            className="m-a-chat-chatKey-text font-t-cont">{list.chatKey}</span>
                                                                    </div>
                                                            }
                                                            <div
                                                                className="m-a-chat-commingTime font-t-cont">{list && convertToNonMemberDate(list.regTime)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                        <div style={{marginTop:"30px"}}>
                                            <img onClick={()=> setNUserRemoveSt(true)} className="wd-30 ht-30" alt="All Clean"
                                                 src={trash}/>
                                        </div>
                                    </div>
                                </div>
                                :
                                // [구매대행 API] 상점사채팅탭
                                storeChat ?
                                    <div className="m-a-body-container">
                                        {renderChatTabs()}
                                        <AdminStoreChatTab compact onUnreadTotalChange={setLcStoreChatCount}/>
                                    </div>
                                    :
                                    null
                        }
                    </div>
            }
            {nonShowChatFile ?
                <MChatFileUpload nonShowChatFileClose={nonShowChatFileClose}
                                      nonSelectedFile={nonSelectedFile} nonShowChatFile={nonShowChatFile}
                                      nonSelectedFileUrl={nonSelectedFileUrl}
                                      saveNonChatFile={saveNonChatFile}/>
                :
                nonSelectedClickSt ?
                    <MChatFileDownModal nonSelectedClickSt={nonSelectedClickSt}
                                        nonClickFileClose={nonClickFileClose}
                                        nonSelectedClickFile={nonSelectedClickFile}
                                        nonDownloadFile={nonDownloadFile}/>
                    :
                    nonChatFileModifySt ?
                        <MChatFileUpload nonChatFileModifySt={nonChatFileModifySt}
                                              nonChatFileModifyFalseFn={nonChatFileModifyFalseFn}
                                              nonChatFileModify={nonChatFileModify}
                                              nonMessageToModify={nonMessageToModify}/>
                        :
                        nonChatModifySt ?
                            <MChatModifyModal nonChatModifyFalseFn={nonChatModifyFalseFn}
                                              nonChatModifySt={nonChatModifySt}
                                              nonMessageToModify={nonMessageToModify}
                                              nonChatFileModify={nonChatFileModify}/>
                            :
                            nonChatDeleteSt ?
                                <MMsgSelectModal nonChatDeleteSt={nonChatDeleteSt}
                                                 nonChatDeleteFalseFn={nonChatDeleteFalseFn}
                                                 chatDeleteMsg1={chatDeleteMsg1} chatDeleteMsg2={chatDeleteMsg2}
                                                 nonMessageToModify={nonMessageToModify} deleteNonChat={deleteNonChat}/>
                                :
                                showChatFile ?
                                    <MChatFileUpload showChatFileClose={showChatFileClose}
                                                          selectedFile={selectedFile}
                                                          selectedFileUrl={selectedFileUrl}
                                                          saveChatFile={saveChatFile}/>
                                    :
                                    chatFileModifySt ?
                                        <MChatFileUpload chatFileModifySt={chatFileModifySt}
                                                              chatFileModifyFalseFn={chatFileModifyFalseFn}
                                                              chatFileModify={chatFileModify}
                                                              messageToModify={messageToModify}/>
                                        :
                                        chatModifySt ?
                                            <MChatModifyModal chatModifyFalseFn={chatModifyFalseFn}
                                                              messageToModify={messageToModify}
                                                              chatFileModify={chatFileModify}/>
                                            :
                                            chatDeleteSt ?
                                                <MMsgSelectModal chatDeleteSt={chatDeleteSt}
                                                                 chatDeleteFalseFn={chatDeleteFalseFn}
                                                                 chatDeleteMsg1={chatDeleteMsg1}
                                                                 chatDeleteMsg2={chatDeleteMsg2}
                                                                 messageToModify={messageToModify}
                                                                 deleteChat={deleteChat}/>
                                                :
                                                selectedClickSt ?
                                                    <MChatFileDownModal selectedClickSt={selectedClickSt}
                                                                        clickFileClose={clickFileClose}
                                                                        selectedClickFile={selectedClickFile}
                                                                        downloadFile={downloadFile}/>
                                                    :
                                                    fileSizeOverSt ?
                                                        <MMsgCheckModal
                                                            fileSizeOverSt={fileSizeOverSt}
                                                            closeFileSizeOverSt={closeFileSizeOverSt}/>
                                                        :
                                                        downloadFileComplSt ?
                                                            <MMsgCheckModal downloadFileComplSt={downloadFileComplSt}
                                                                            closeDownloadFileCompl={closeDownloadFileCompl}/>
                                                            :
                                                            nUserRemoveSt ?
                                                                <MMsgSelectModal
                                                                    nUserRemoveSt={nUserRemoveSt}
                                                                    nUserRemoveMsgTitle={nUserRemoveMsgTitle}
                                                                    nUserRemoveMsgContent={nUserRemoveMsgContent}
                                                                    closeNUserRemoveSt={closeNUserRemoveSt}
                                                                    nUserAllChatRemove={nUserAllChatRemove}/>
                                                                :
                                                            null
            }
            {isMacroPopupVisible && (
                <div className="m-a-chat-admin-macro-popup-frame" onClick={toggleMacroPopup}>
                    <div className="m-a-chat-admin-macro-popup" onClick={(e) => e.stopPropagation()}>
                        <div className="m-a-chat-admin-macro-header-frame user-center">
                            <div className="m-a-chat-admin-macro-header-text font-t-head font-s-17">매크로</div>
                        </div>
                        <div className="m-a-chat-admin-macro-body-frame1">
                            {macroMstList.map((mst, mstIdx) => (
                                <div key={mstIdx} onClick={() => fetchNonMacroDtList(mstIdx)}
                                     className="m-a-chat-admin-macro-body-frame2">
                                    <div
                                        className="m-a-chat-admin-macro-body-parent font-t-title user-center">{mst && mst.title}</div>
                                    {nonSelectedMacroMstIndex === mstIdx ?
                                        <div className="m-a-chat-admin-macro-body-child-frame">
                                            {nonSelectedMacroMstIndex === mstIdx && macroDtList && macroDtList.map((dt, dtIdx) => (
                                                <div key={dtIdx} tabIndex='0'
                                                     onClick={chatStarted ? () => sendOrdMacroMessage(dt.content) : () => sendNonMacroMessage(dt.content)}
                                                     className="m-a-chat-admin-macro-body-child font-t-cont user-center">{dt && dt.title}</div>
                                            ))}
                                        </div>
                                        :
                                        null
                                    }
                                </div>
                            ))}
                        </div>
                        <div className="m-a-chat-admin-macro-footer-frame user-center">
                            <button onClick={() => setIsMacroPopupVisible(false)}
                                    className="m-a-colorBt ht-40 m-b-5 wd-80">
                                <div className="m-a-colorBt-text font-t-cont">Close</div>
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default MAdminOrderChatPg
